import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { useBrandStore } from "../store/brandStore";
import {
  Card,
  Select,
  Form,
  Col,
  Row,
  Button,
  Table,
  Modal,
  Divider,
  Tooltip,
  Alert,
  InputNumber,
  DatePicker,
  List,
  Space,
  Checkbox,
  Input,
  Radio,
  Typography,
} from "antd";
import {
  ArrowRightOutlined,
  DownloadOutlined,
  EditOutlined,
  FilterOutlined,
  InfoCircleOutlined,
  WarningFilled,
} from "@ant-design/icons";
import {
  RFMType,
  RFMTier,
  RFMTierDescriptions,
  RFMPeriod,
} from "../constants/enums";
import { brandRFMSettingService } from "../services/brandRFMSettingService";
import type { ColumnsType } from "antd/es/table";
import { useBrandRFMSettingStore } from "../store/brandRFMSettingStore";
import CustomModal from "../components/common/Modal";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Legend,
  ResponsiveContainer,
  Cell,
  Tooltip as RechartsTooltip,
  CartesianGrid,
  LabelList,
  ReferenceArea,
} from "recharts";
import { dashboardService } from "../services/dashboardService";
import moment from "moment";
import { RoutePaths } from "../routes/route";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs, { Dayjs } from "dayjs";
import { brandRFMProfileService } from "../services/brandRFMProfileService";
import { BrandRFMProfile } from "../models/brandRFMProfile";
import RFMGeneratingModal from "../components/common/GeneratingDataModal";
import { BrandRFMSetting } from "../models/brandRFMSetting";
import { Option } from "../models/option";

import {
  prepareActiveRFMProfile,
  prepareRFMSettings,
} from "../utils/rfmHelper";
import { campaignService } from "../services/campaignService";

interface RFMData {
  RFMTier: string;
  RFMType: string;
  Description: string;
  TotalMembers: number;
}

interface MemberSegment {
  Segment: string;
  SegmentName: string;
  SegmentDescription: string;
  Count: number;
}

interface TopPerformers {
  UserId: number;
  FirstName: string;
  LastName: string;
  ContactIdd: string;
  ContactNumber: string;
  Email: string;
  BirthDate: string;
  CountryName: string;
  Address: string;
  Postcode: string;
  Tier: string;
  RegistrationService: string;
  BrandName: string;
  StoreName: string;
  TotalOrderCount: number;
  LastTransactionDate: string;
  TotalOrderValue: number;
  RegistrationDate: string;
  RecencyCategory: number;
  FrequencyCategory: number;
  MonetaryCategory: number;
  PrimarySegmentName: string;
  SMSRewardReminder: boolean;
  EmailRewardReminder: boolean;
  AdditionalSMSMarketing: boolean;
  AdditionalEmailMarketing: boolean;
}

interface TierData {
  tier: number;
  baseStart: number;
  baseEnd: number;
}

const Home: React.FC = () => {
  // =====================
  // State Declarations
  // =====================`
  const navigate = useNavigate();
  const location = useLocation();
  const { Option } = Select;
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const { Text } = Typography;

  const hasFetched = useRef(false);
  const isTablet = window.innerWidth >= 768 && window.innerWidth <= 1024;
  const isMobile = window.innerWidth < 768;
  const [filterMode, setFilterMode] = useState<"segment" | "criteria">(
    "segment",
  );
  const [filterCampaign, setFilterCampaign] = useState<number | null>(null);
  const [appliedFilters, setAppliedFilters] = useState({
    filterMode: "segment",
    segmentIds: [] as number[],
    recencyIds: [] as number[],
    frequencyIds: [] as number[],
    monetaryIds: [] as number[],
  });

  const [isDefaultProfile, setIsDefaultProfile] = useState(false);
  const [isValueChanges, setIsValueChanges] = useState(false);
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  // Store
  const AllStores = "All Stores";
  const AllBrand = "All Brands";
  const [includePointBalance] = useState(true);
  const [includeVoucherData] = useState(true);

  const handleDownloadNow = () => {
    downloadTopPerformers();
    setIsModalDownloadVisible(false);
  };
  // Oldest Data Date
  const [oldestDate, setOldestDate] = useState<Date | null>(null);
  interface DashboardParams {
    brandId: string;
    selectedSegment?: string;
    selectedSegmentId?: number;
    startDate: string;
    endDate: string;
    periodEnumValue: string;
    selectedMembers: number[] | number | null;
    finalRegisteredBrand: string[];
    finalRegisteredStore: any[];
    finalPurchaseBrand: string[];
    finalPurchaseStore: any[];
    rfmFilter: number[];
    recencyFilter: number[];
    frequencyFilter: number[];
    monetaryFilter: number[];
    campaignFilter: number | null;
  }
  // Dashboard params
  const [dashboardParams, setDashboardParams] = useState<DashboardParams>({
    brandId: "",
    selectedSegment: undefined,
    selectedSegmentId: undefined,
    startDate: "",
    endDate: "",
    periodEnumValue: "",
    selectedMembers: [],
    finalRegisteredBrand: [],
    finalRegisteredStore: [],
    finalPurchaseBrand: [],
    finalPurchaseStore: [],
    rfmFilter: [],
    recencyFilter: [],
    frequencyFilter: [],
    monetaryFilter: [],
    campaignFilter: null,
  });
  // Selected Filters

  const [selectedMembers, setSelectedMembers] = useState<number | null>(null);
  const [selectedRegisteredBrand, setSelectedBrand] = useState<string[]>([
    AllBrand,
  ]);
  const [selectedRegisteredStore, setSelectedStore] = useState<string[]>([
    AllStores,
  ]);
  const [selectedPurchaseBrand, setSelectedPurchaseBrand] = useState<string[]>([
    AllBrand,
  ]);
  const [selectedPurchaseStore, setSelectedPurchaseStore] = useState<string[]>([
    AllStores,
  ]);

  const [selectedSegment, setSelectedSegment] = useState<string | null>(
    "Recent Members",
  );
  const [selectedSegmentId, setSelectedSegmentId] = useState<number | null>(
    null,
  );
  const [selectedPeriod, setSelectedPeriod] = useState<number>(12);

  // Hooks & Store
  const { brandId } = useBrandStore();
  const { brandRFMSetting, setBrandRFMSetting } = useBrandRFMSettingStore();

  // Profile
  const [rfmProfile, setRfmProfile] = useState<any[]>([]);
  const [defaultProfile, setDefaultProfile] = useState<any[]>([]);
  const [selectedRFMProfile, setSelectedRFMProfile] = useState<any>(null);
  const [selectKey, setSelectKey] = useState(0);
  const isDisabled = !(
    selectedRFMProfile?.Name === "Full Service Default Profiles" ||
    selectedRFMProfile?.Name === "Quick Service Default Profiles"
  );

  const makeDefaultProfile = useCallback(
    async (
      brandRFMProfileSetting: BrandRFMSetting[],
      overrides: Partial<{
        Id: number;
        Name: string;
        Description: string;
      }> = {},
    ) => {
      const settings = Array.isArray(brandRFMProfileSetting)
        ? brandRFMProfileSetting
        : [];

      return {
        Id: overrides.Id ?? 0,
        BrandId: brandId,
        Name: overrides.Name ?? "Full Service Default Profiles",
        Description: overrides.Description ?? "Full Service Default Profiles",
        CreatedDate: new Date().toISOString(),
        BrandRFMProfileSetting: settings,
      };
    },
    [brandId],
  );

  // Brand & Outlet
  const [listPurchaseBrandFilter, setListPurchaseBrandFilter] = useState<any[]>(
    [],
  );
  const [listPurchaseStoreFilter, setListPurchaseStoreFilter] = useState<any[]>(
    [],
  );
  const [listRegisteredBrandFilter, setListRegisteredBrandFilter] = useState<
    any[]
  >([]);
  const [listRegisteredStoreFilter, setListRegisteredStoreFilter] = useState<
    any[]
  >([]);
  const [listBrandStore, setListBrandStore] = useState<any[]>([]);
  const [listCampaign, setListCampaign] = useState<Option[] | null>([]);

  // RFM Settings
  const [rfmSettings, setRfmSettings] = useState<any[]>([]);
  const [updatedBrandRFMSetting, setUpdatedBrandRFMSetting] = useState<any[]>();

  // UI State
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [isModalDownloadVisible, setIsModalDownloadVisible] = useState(false);
  const [isModalColumnVisible, setIsModalColumnVisible] = useState(false);
  const [isModalFilterVisible, setIsModalFilterVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isModalSuccessVisible, setIsModalSuccessVisible] = useState(false);
  const [isModalCreateProfileVisible, setIsModalCreateProfileVisible] =
    useState(false);
  const [isModalSelectedPeriodVisible, setIsModalSelectedPeriodVisible] =
    useState(false);
  const [isConfirmationModalVisible, setIsConfirmationModalVisible] =
    useState(false);
  const [
    isConfirmationModalProfileVisible,
    setIsConfirmationModalProfileVisible,
  ] = useState(false);
  const [confirmationProfile, setConfirmationProfile] = useState(false);
  const [
    isUpdateDefaultModalSuccessVisible,
    setIsUpdateDefaultModalSuccessVisible,
  ] = useState(false);
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
  const [activeTab, setActiveTab] = useState("Recency");
  const [isFetching, setIsFetching] = useState(false);
  const [labelTimeRange, setLabelTimeRange] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [isTypingEndValue, setIsTypingEndValue] = useState(false);
  const [defaultSetting, setDefaultSetting] = useState<
    BrandRFMSetting[] | null
  >(null);
  const [tooltipTexts, setTooltipTexts] = useState<Record<string, string>>({});

  // PDPAMember Counts
  const [countFullPDPAMember, setCountFullPDPAMember] = useState(0);
  const [countPartialPDPAMember, setCountPartialPDPAMember] = useState(0);
  const [countMemberFilter, setCountMemberFilter] = useState(0);

  // Cut-off Date Selections
  const now = dayjs().subtract(1, "day");
  const [cutOffDateInEdit, setCutOffDateInEdit] = useState<string>(
    moment().subtract(1, "year").subtract(1, "day").format("YYYY-MM-DD"),
  );
  const [dateError, setDateError] = useState<string | null>(null);
  const [rangeValue, setRangeValue] = useState<[Dayjs, Dayjs] | null>([
    dayjs().subtract(2, "year").subtract(1, "day"),
    now,
  ]);
  const [pickerValue, setPickerValue] = useState<[Dayjs, Dayjs] | null>([
    dayjs().subtract(2, "year").subtract(1, "day"),
    now,
  ]);
  const oldest = dayjs(oldestDate);

  const getBestPresetLabel = (date: Date) => {
    const dateDefault = dayjs(date);

    if (!dateDefault.isValid()) return "Last 2 Years";

    const diffMonths = now.diff(dateDefault, "month", true);

    if (diffMonths < 6) {
      return "Last 3 Months";
    } else if (diffMonths < 9) {
      return "Last 6 Months";
    } else if (diffMonths < 12) {
      return "Last 9 Months";
    } else if (diffMonths < 24) {
      return "Last 1 Year";
    } else {
      return "Last 2 Years";
    }
  };

  const rawPresets: {
    label: string;
    getRange: () => [Dayjs, Dayjs];
  }[] = [
    {
      label: "Lifetime",
      getRange: () => [oldest.isValid() ? oldest : dayjs("2000-01-01"), now],
    },
    {
      label: "Last 2 Years",
      getRange: () => [dayjs().subtract(2, "year").subtract(1, "day"), now],
    },
    {
      label: "Last 1 Year",
      getRange: () => [dayjs().subtract(1, "year").subtract(1, "day"), now],
    },
    {
      label: "Last 9 Months",
      getRange: () => [dayjs().subtract(9, "month").subtract(1, "day"), now],
    },
    {
      label: "Last 6 Months",
      getRange: () => [dayjs().subtract(6, "month").subtract(1, "day"), now],
    },
    {
      label: "Last 3 Months",
      getRange: () => [dayjs().subtract(3, "month").subtract(1, "day"), now],
    },
    {
      label: "Custom Range",
      getRange: () => {
        if (oldest.isValid()) {
          const diffMonths = now.diff(oldest, "month");
          if (diffMonths > 12) {
            return [dayjs().subtract(1, "year").subtract(1, "day"), now];
          } else {
            return [oldest, now];
          }
        } else {
          return [dayjs().subtract(1, "year").subtract(1, "day"), now];
        }
      },
    },
  ];

  const rangePresets = rawPresets.map((preset) => {
    const range = preset.getRange();
    const rangeStart = range[0];

    let disabled = false;
    if (
      preset.label === "Lifetime" ||
      preset.label === "Custom Range" ||
      preset.label === "Last 3 Months"
    ) {
      disabled = false;
    } else if (oldest.isValid()) {
      if (oldest.isAfter(rangeStart)) {
        disabled = true;
      }
    }

    return {
      label: preset.label,
      value: range,
      disabled,
    };
  });

  const labelToRFMTPeriodMap: Record<string, RFMPeriod> = {
    Lifetime: RFMPeriod.Lifetime,
    "Last 2 Years": RFMPeriod.Last2Years,
    "Last 1 Year": RFMPeriod.Last1Year,
    "Last 9 Months": RFMPeriod.Last9Months,
    "Last 6 Months": RFMPeriod.Last6Months,
    "Last 3 Months": RFMPeriod.Last3Months,
    "Custom Range": RFMPeriod.CustomRange,
  };

  const placeholder: string = useMemo(() => {
    if (rangeValue && rangeValue[0] && rangeValue[1]) {
      const matches = rangePresets.filter((preset) => {
        return (
          Array.isArray(preset.value) &&
          preset.value[0]?.isSame(rangeValue[0], "day") &&
          preset.value[1]?.isSame(rangeValue[1], "day")
        );
      });

      if (matches.length > 0) {
        const specific = matches.find((preset) => preset.label !== "Lifetime");
        return specific ? specific.label : matches[0].label;
      }

      return "Custom Range";
    }
    return "Select date range";
  }, [rangeValue, rangePresets]);

  const handlePresetClick = (preset: {
    label: string;
    value: [Dayjs, Dayjs];
  }) => {
    if (placeholder === "Custom Range" && preset.label === "Custom Range") {
      setLabelTimeRange(preset.label);
      setPickerValue(rangeValue);
      return;
    }
    setLabelTimeRange(preset.label);
    const [d1, d2] = preset.value;
    const [start, end] = d1.isBefore(d2) ? [d1, d2] : [d2, d1];

    setPickerValue([start, end]);
  };

  const handleChangePeriod = () => {
    if (!pickerValue || !pickerValue[0] || !pickerValue[1]) return;

    const [start, end] = pickerValue;
    setRangeValue([start, end]);

    const { transformedData } = applyFrequencyDataUpdate(
      brandRFMSetting,
      brandRFMSetting,
      selectedPeriod,
      undefined,
      [start, end],
    );

    setRfmSettings(transformedData);
    closeModalSelectedPeriod();
  };

  const handleCancelPeriod = () => {
    setDateError(null);

    setLabelTimeRange(placeholder);
    setIsModalSelectedPeriodVisible(false);
  };

  // Data for Charts & Segments
  const [dataBarChart, setDataBarChart] = useState<RFMData[]>([]);
  const [cardSegmentCountData, setCardSegmentCountData] = useState<
    MemberSegment[]
  >([]);
  const [dataSegmentBarChart, setDataSegmentBarChart] = useState<
    MemberSegment[]
  >([]);
  const [dataTopPerformers, setDataTopPerformers] = useState<TopPerformers[]>(
    [],
  );

  const getRfmOptions = (category: "Recency" | "Frequency" | "Monetary") => [
    { label: `All ${category} Value`, value: "all" },
    ...Object.values(RFMTier)
      .filter((v) => typeof v === "number")
      .map((tier) => ({
        label: RFMTierDescriptions[tier as RFMTier],
        value: tier.toString(),
      })),
  ];

  const recencyOptions = getRfmOptions("Recency");
  const frequencyOptions = getRfmOptions("Frequency");
  const monetaryOptions = getRfmOptions("Monetary");
  const [rfmFilter, setRfmFilter] = useState<string[] | null>([
    "-2",
    "-3",
    "-4",
  ]);
  const getDefaultFilter = (options: { value: string }[]) =>
    options.map((o) => o.value);

  const [recencyFilter, setRecencyFilter] = useState<string[]>(
    getDefaultFilter(recencyOptions),
  );
  const [frequencyFilter, setFrequencyFilter] = useState<string[]>(
    getDefaultFilter(frequencyOptions),
  );
  const [monetaryFilter, setMonetaryFilter] = useState<string[]>(
    getDefaultFilter(monetaryOptions),
  );

  const segmentOptions = [
    { label: "All Member Segment", value: "all" },
    ...(dataSegmentBarChart?.map((segment) => ({
      label: segment.SegmentName,
      value: `${segment.Segment}`,
    })) ?? []),
  ];

  // =====================
  // Modal Handlers
  // =====================
  const showModalSuccess = () => setIsModalSuccessVisible(true);
  const closeModalSuccess = () => setIsModalSuccessVisible(false);
  const showModalError = () => setIsErrorModalVisible(true);
  const closeErrorModal = () => setIsErrorModalVisible(false);
  const showModalSelectedPeriod = () => setIsModalSelectedPeriodVisible(true);
  const closeModalSelectedPeriod = () => setIsModalSelectedPeriodVisible(false);
  const [messageModalSuccess, setMessageModalSuccess] = useState("");
  const [titleModalSuccess, setTitleModalSuccess] = useState("");

  const handleCreateProfile = async () => {
    try {
      setLoadingButton(true);
      const valuesProfile = await form1.validateFields();
      const isDuplicate = rfmProfile.some(
        (item) =>
          item.Name.trim().toLowerCase() ===
          valuesProfile.name.trim().toLowerCase(),
      );

      if (isDuplicate) {
        setLoadingButton(false);
        form1.setFields([
          {
            name: "name",
            errors: ["Profile name already exists. Please choose another."],
          },
        ]);
        return;
      }
      if (rfmProfile.length >= 10) {
        setLoadingButton(false);
        form1.setFields([
          {
            name: "name",
            errors: [
              "Maximum of 10 profiles allowed. Please delete one before adding.",
            ],
          },
        ]);
        return;
      }

      const valuesCriteria = await form.validateFields();
      const settings = await updateAllBrandRFMSetting(valuesCriteria);

      const updatedSettings = settings.map((setting: any) => ({
        ...setting,
        Id: 0,
      }));
      const profile: BrandRFMProfile = {
        Id: 0,
        BrandId: brandId,
        Name: valuesProfile.name,
        Description: valuesProfile.description,
        IsActive: true,
        IsAuto: false,
        CreatedDate: new Date(),
        BrandRFMProfileSetting: updatedSettings,
      };
      await brandRFMProfileService.createBrandRFMProfile(profile);
      hasFetched.current = false;

      await fetchDashboardData();
      await fetchBrandRFMProfile();

      setIsModalCreateProfileVisible(false);
      form1.resetFields();

      setMessageModalSuccess(
        `The profile ${valuesProfile.name} saved as new successfully.`,
      );
      setTitleModalSuccess("Profile Created");
      setIsValueChanges(false);
      setConfirmationProfile(false);
      showModalSuccess();
    } catch (errorInfo) {
      console.error("Validation Failed:", errorInfo);
    } finally {
      setLoadingButton(false);
    }
  };

  const handleUpdateProfile = async () => {
    try {
      const valuesCriteria = await form.validateFields();
      const settings = await updateAllBrandRFMSetting(valuesCriteria);
      const updatedSettings = settings.map((setting) => {
        const matchedProfileSetting =
          selectedRFMProfile?.BrandRFMProfileSetting?.find(
            (profileSetting: any) =>
              profileSetting.RFMType === setting.RFMType &&
              profileSetting.RFMTier === setting.RFMTier,
          );

        return {
          ...setting,
          Id: matchedProfileSetting?.Id,
        };
      });

      const profile: BrandRFMProfile = {
        Id: selectedRFMProfile?.Id,
        BrandId: brandId,
        Name: selectedRFMProfile?.Name,
        Description: selectedRFMProfile?.Description,
        IsActive: true,
        IsAuto: selectedRFMProfile?.IsAuto,
        CreatedDate: selectedRFMProfile?.CreatedDate,
        BrandRFMProfileSetting: updatedSettings,
      };
      await brandRFMProfileService.updateBrandRFMProfile(profile);
      hasFetched.current = false;

      await fetchDashboardData();
      await fetchBrandRFMProfile();

      setIsValueChanges(false);
      setConfirmationProfile(false);

      setMessageModalSuccess(
        `The profile ${selectedRFMProfile.Name} has been successfully updated.`,
      );
      setTitleModalSuccess("Profile Overwritten");

      showModalSuccess();
    } catch (errorInfo) {
      console.error("Validation Failed:", errorInfo);
    }
  };

  // =====================
  // Cut-off Date Options
  // =====================

  const optionsCutOffDateOnEdit = [
    {
      label: "Every 12 Months",
      value: moment()
        .subtract(12, "months")
        .subtract(1, "day")
        .format("YYYY-MM-DD"),
      period: 12,
    },
    {
      label: "Every 6 Months",
      value: moment()
        .subtract(6, "months")
        .subtract(1, "day")
        .format("YYYY-MM-DD"),
      period: 6,
    },
    {
      label: "Every 3 Months",
      value: moment()
        .subtract(3, "months")
        .subtract(1, "day")
        .format("YYYY-MM-DD"),
      period: 3,
    },
  ];

  // =====================
  // Data Transformation
  // =====================
  const transformRFMData = (
    data: any[],
    rangeValueOptional?: [Dayjs, Dayjs] | null,
  ) => {
    return Object.values(RFMType)
      .filter((type) => typeof type === "number")
      .map((type) => {
        const rowData: any = {
          key: type,
          definition: RFMType[type as number],
        };

        Object.values(RFMTier)
          .filter((tier) => typeof tier === "number")
          .forEach((tier) => {
            const setting = data.find(
              (item) => item.RFMType === type && item.RFMTier === tier,
            );

            let formattedValue = "-";
            let startValue = 0;
            let endValue = 0;
            if (setting) {
              startValue = parseFloat(setting.RFMStartValue);
              endValue = parseFloat(setting.RFMEndValue);

              const diffInDays =
                (rangeValueOptional ?? rangeValue)
                  ? (rangeValueOptional ?? rangeValue)![1].diff(
                      (rangeValueOptional ?? rangeValue)![0],
                      "day",
                    )
                  : 0;

              if (type === RFMType.Recency && startValue > diffInDays) {
                formattedValue = "Out Of Range";
              } else {
                if (tier === RFMTier.VeryHigh) {
                  if (type === RFMType.Frequency) {
                    formattedValue =
                      endValue === 0
                        ? `${
                            Number.isInteger(startValue)
                              ? startValue
                              : startValue.toFixed(1)
                          }+ orders`
                        : `${
                            Number.isInteger(startValue)
                              ? startValue
                              : startValue.toFixed(1)
                          } - ${
                            Number.isInteger(endValue)
                              ? endValue
                              : endValue.toFixed(1)
                          } orders`;
                  } else if (type === RFMType.Monetary) {
                    formattedValue = `$${startValue.toLocaleString("en-US")}+`;
                  } else {
                    if (startValue === 0) {
                      formattedValue = ` <= ${endValue} days`;
                    } else {
                      formattedValue = ` ${startValue} - ${endValue} days`;
                    }
                  }
                } else {
                  if (type === RFMType.Recency) {
                    formattedValue =
                      endValue === 0
                        ? `${startValue}+ days`
                        : `${startValue} - ${endValue} days`;
                  } else if (type === RFMType.Frequency) {
                    if (startValue === 0) {
                      formattedValue = `<= ${
                        Number.isInteger(endValue)
                          ? endValue
                          : endValue.toFixed(1)
                      } orders`;
                    } else {
                      formattedValue =
                        startValue === endValue
                          ? `${
                              Number.isInteger(startValue)
                                ? startValue
                                : startValue.toFixed(1)
                            } orders`
                          : ` ${
                              Number.isInteger(startValue)
                                ? startValue
                                : startValue.toFixed(1)
                            } - ${
                              Number.isInteger(endValue)
                                ? endValue
                                : endValue.toFixed(1)
                            } orders`;
                    }
                  } else if (type === RFMType.Monetary) {
                    if (startValue === 0) {
                      formattedValue = `<= $${endValue.toLocaleString(
                        "en-US",
                      )}`;
                    } else {
                      formattedValue = `$${startValue.toLocaleString(
                        "en-US",
                      )} - $${endValue.toLocaleString("en-US")}`;
                    }
                  }
                }
              }
            }

            rowData[RFMTier[tier as number]] = formattedValue;
          });

        return rowData;
      });
  };

  // =====================
  // Frequency Updates
  // =====================
  const applyFrequencyDataUpdate = (
    baseSettings: any[],
    frequencySettings: any[],
    selectedPeriod: number,
    selectedOptionPeriod?: number,
    rangeValueOptional?: [Dayjs, Dayjs] | null,
  ) => {
    let newFrequencyData: any[] = [];

    if (selectedOptionPeriod !== undefined) {
      newFrequencyData = getFrequencyTiers(
        baseSettings,
        selectedOptionPeriod,
        selectedPeriod,
      );
    } else {
      newFrequencyData = getFrequencyTiers(baseSettings, selectedPeriod);
    }
    const updatedSettings = frequencySettings.map((item: any) =>
      item.RFMType === 2
        ? item.Id === 0
          ? (newFrequencyData.find(
              (f: any) =>
                f.RFMTier === item.RFMTier && f.RFMType === item.RFMType,
            ) ?? item)
          : (newFrequencyData.find((f: any) => f.Id === item.Id) ?? item)
        : item,
    );
    let transformedData;
    if (rangeValueOptional != null) {
      transformedData = transformRFMData(updatedSettings, rangeValueOptional);
    } else {
      transformedData = transformRFMData(updatedSettings);
    }

    return {
      newFrequencyData,
      updatedSettings,
      transformedData,
    };
  };

  // =====================
  // UseEffect
  // =====================
  const resetTooltipText = () => {
    if (brandRFMSetting) {
      const newValues = brandRFMSetting.reduce((acc: any, tier: any) => {
        acc[`${tier.RFMType}-${tier.RFMTier}-start`] = tier.RFMStartValue;
        acc[`${tier.RFMType}-${tier.RFMTier}-end`] =
          tier.RFMEndValue === 0 ? "" : tier.RFMEndValue;
        return acc;
      }, {});

      updateTooltipText(newValues);
    }
  };

  const updateTooltipText = useCallback(
    (newValues: any) => {
      const entries = Object.entries(newValues);

      entries.forEach(([key, value]) => {
        const isStart = key.includes("start");
        const isEnd = key.includes("end");

        if (typeof value === "string" || typeof value === "number") {
          let num: any = parseFloat(value.toString().replace(/,/g, "."));
          const rounded = Math.round(num * 10) / 10;
          const keyParts = key.split("-");

          if (parseInt(keyParts[0]) === RFMType.Frequency) {
            num = Number.isInteger(rounded)
              ? rounded.toString()
              : rounded.toFixed(1);
          }

          if (parseInt(keyParts[0]) === RFMType.Monetary) {
            if (parseInt(keyParts[1]) === RFMTier.VeryHigh) {
              const startTierKey =
                keyParts[0] + "-" + (parseInt(keyParts[1]) + 1) + "-end";
              const value = form.getFieldValue(startTierKey);
              num = (parseFloat(value) + 0.01).toFixed(2);
            }
          }

          setTooltipTexts((prev) => ({
            ...prev,
            [key]:
              value !== undefined
                ? isStart
                  ? `Skip this to include values higher than ${num}`
                  : isEnd
                    ? `Skip this to include values lower than ${num}`
                    : ""
                : "",
          }));
        }
      });
    },
    [form, setTooltipTexts],
  );

  useEffect(() => {
    if (filterCampaign !== null) {
      setSelectedKeys(columnsTopPerformers.map((col) => col.key as string));
    }
  }, [filterCampaign]);

  useEffect(() => {
    if (updatedBrandRFMSetting && updatedBrandRFMSetting.length > 0) {
      const newValues = updatedBrandRFMSetting.reduce((acc: any, tier: any) => {
        acc[`${tier.RFMType}-${tier.RFMTier}-start`] = tier.RFMStartValue;
        acc[`${tier.RFMType}-${tier.RFMTier}-end`] =
          tier.RFMEndValue === 0 ? "" : tier.RFMEndValue;
        return acc;
      }, {});

      form.setFieldsValue(newValues);
      updateTooltipText(newValues);
    }
  }, [updatedBrandRFMSetting, form, cutOffDateInEdit, updateTooltipText]);

  useEffect(() => {
    if (!brandId) return;
    const fetchSettings = async () => {
      const setting = await defaultSettings(brandId);

      if (setting) {
        setDefaultSetting(setting?.FullService);

        const profile1 = await makeDefaultProfile(setting?.FullService, {
          Id: 0,
          Name: "Full Service Default Profiles",
        });

        const profile2 = await makeDefaultProfile(setting?.QuickService, {
          Id: -1,
          Name: "Quick Service Default Profiles",
        });

        setDefaultProfile([profile1, profile2]);
      }
    };

    const fetchData = async () => {
      await Promise.all([fetchOldestMemberSignup(), fetchSettings()]);
    };

    fetchData();
    fetchListCampaign();
  }, [brandId]);

  useEffect(() => {
    if (!brandId || defaultProfile.length === 0) return;
    fetchBrandRFMProfile();
  }, [brandId, defaultProfile]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const shouldFetch =
        (selectedSegment !== null || selectedSegmentId !== null) &&
        Array.isArray(rangeValue) &&
        rangeValue.length === 2 &&
        !isFetching;

      if (shouldFetch) {
        setIsFetching(true);
        fetchDashboardData().finally(() => {
          setIsFetching(false);
        });
      }
    }, 100);

    return () => clearTimeout(timeout);
  }, [rangeValue, appliedFilters]);

  // =====================
  // Form Actions
  // =====================
  const resetEditForm = async (
    resetSelectedPeriod = true,
    resetTooltip = true,
    resetForm = true,
  ) => {
    setIsValueChanges(false);
    setIsEditModalVisible(false);
    if (resetSelectedPeriod) {
      setCutOffDateInEdit(
        moment().subtract(1, "year").subtract(1, "day").format("YYYY-MM-DD"),
      );
      setSelectedPeriod(12);
    }
    if (resetForm) {
      form.resetFields();
      const { transformedData, updatedSettings: newRFMSettings } =
        applyFrequencyDataUpdate(
          brandRFMSetting,
          brandRFMSetting,
          selectedPeriod,
        );
      const formValues: Record<string, any> = {};
      setRfmSettings(transformedData);
      for (const setting of newRFMSettings) {
        formValues[`${setting.RFMType}-${setting.RFMTier}-start`] =
          setting.RFMStartValue;
        formValues[`${setting.RFMType}-${setting.RFMTier}-end`] =
          setting.RFMEndValue;
      }

      form.setFieldsValue(formValues);
      updateTooltipText(formValues);
    }
    if (resetTooltip) {
      resetTooltipText();
    }
    setIsTyping(false);
    const activeProfiles = rfmProfile?.filter((profile) => profile.IsActive);
    if (activeProfiles) {
      const { finalProfile, mappedData, newRFMSettings, transformedData } =
        prepareActiveRFMProfile(
          activeProfiles?.[0],
          defaultProfile,
          brandId ?? "",
          selectedPeriod,
          applyFrequencyDataUpdate,
        );

      setSelectedRFMProfile(finalProfile);
      setBrandRFMSetting(mappedData);
      setRfmSettings(transformedData);
      setUpdatedBrandRFMSetting(newRFMSettings);
    }
    setSelectKey((prev) => prev + 1);

    setActiveTab("Recency");
    setIsDefaultProfile(false);
  };

  const updateAllBrandRFMSetting = async (values: any) => {
    const updatedSettings = updateRFMSettings(brandRFMSetting, values);
    const fixedFrequencyData = getFrequencyTiers(
      updatedSettings ?? [],
      3,
      selectedPeriod,
    );

    const finalUpdatedSettings = updatedSettings.map((item) => {
      if (item.RFMType === 2) {
        const matchedTier = fixedFrequencyData.find(
          (fixed) => fixed.RFMType === 2 && fixed.RFMTier === item.RFMTier,
        );

        return {
          ...item,
          RFMStartValue: matchedTier?.RFMStartValue ?? item.RFMStartValue,
          RFMEndValue: matchedTier?.RFMEndValue ?? item.RFMEndValue,
        };
      }
      return item;
    });
    return finalUpdatedSettings;
  };

  const onFinish = async (values: Record<string, any>) => {
    try {
      if (
        (!selectedRFMProfile || (isDefaultProfile && isValueChanges)) &&
        rfmProfile.length < 10
      ) {
        setConfirmationProfile(false);
        setIsConfirmationModalProfileVisible(false);
        setIsModalCreateProfileVisible(true);
        return;
      }
      if (
        selectedRFMProfile &&
        isValueChanges &&
        !confirmationProfile &&
        !isDefaultProfile
      ) {
        setIsConfirmationModalProfileVisible(true);
        return;
      }
      setLoadingButton(true);
      await handleUpdateProfile();
      hasFetched.current = false;
      setMessageModalSuccess("Criteria RFM has been updated successfully");
      setTitleModalSuccess("Updated Criteria RFM");
      setIsTyping(false);
      setIsValueChanges(false);
      setConfirmationProfile(false);
      showModalSuccess();
    } catch (error) {
      console.error("Error updating settings:", error);
      showModalError();
    } finally {
      setLoadingButton(false);
      setIsValueChanges(false);
      setIsEditModalVisible(false);
    }
  };

  const onFinishFailed = ({ values, errorFields }: any) => {
    if (errorFields && errorFields.length > 0) {
      const firstError = errorFields[0];
      const fieldName = firstError.name[0];

      if (fieldName.startsWith("1-")) {
        setActiveTab("Recency");
      } else if (fieldName.startsWith("2-")) {
        setActiveTab("Frequency");
      } else if (fieldName.startsWith("3-")) {
        setActiveTab("Monetary");
      }
    }
  };

  const onValuesChange = (changedValues: any, allValues: any) => {
    const entries = Object.entries(changedValues);
    const updatedTooltips: Record<string, string> = {};
    entries.forEach(([key, value]) => {
      if (value !== undefined) {
        const isStart = key.includes("start");
        const isEnd = key.includes("end");
        const keyParts = key.split("-");
        const type = keyParts[0] ?? 0;
        const currentTier = keyParts[1] ?? 0;
        const nextTierKey =
          parseInt(type) === RFMType.Recency
            ? `${type}-${parseInt(currentTier) + 1}-start`
            : `${type}-${parseInt(currentTier) - 1}-start`;

        const dataSource =
          parseInt(type) === RFMType.Frequency
            ? (updatedBrandRFMSetting ?? [])
            : (brandRFMSetting ?? []);
        const currentTierGroup = dataSource.filter(
          (t: any) => t.RFMType === parseInt(type),
        );

        const allHaveDecimals =
          parseInt(type) === RFMType.Frequency &&
          parseInt(type) !== RFMType.Recency &&
          currentTierGroup.some((t: any) => {
            const startVal = Number(t.RFMStartValue);
            const endVal = Number(t.RFMEndValue);
            return (
              (!Number.isNaN(startVal) && !Number.isInteger(startVal)) ||
              (!Number.isNaN(endVal) && !Number.isInteger(endVal))
            );
          });
        updatedTooltips[key] = isStart
          ? `Skip this to include values higher than ${value}`
          : isEnd
            ? `Skip this to include values lower than ${value}`
            : "";
        const numericValue =
          typeof value === "string" || typeof value === "number"
            ? parseFloat(value as string)
            : 0;
        var nextTierValue: any =
          numericValue +
          (parseInt(type) === RFMType.Monetary
            ? 0.01
            : allHaveDecimals
              ? 0.1
              : 1);

        if (parseInt(keyParts[0]) === RFMType.Frequency) {
          nextTierValue = Number.isInteger(nextTierValue)
            ? nextTierValue.toString()
            : nextTierValue.toFixed(1);
        }
        if (parseInt(keyParts[0]) === RFMType.Monetary) {
          nextTierValue = Number.isInteger(nextTierValue)
            ? nextTierValue.toString()
            : nextTierValue.toFixed(2);
        }
        updatedTooltips[nextTierKey] = isStart
          ? `Skip this to include values higher than ${nextTierValue}`
          : isEnd
            ? `Skip this to include values lower than ${nextTierValue}`
            : "";
      }
    });

    setTooltipTexts((prev) => ({
      ...prev,
      ...updatedTooltips,
    }));
  };

  // =====================
  // Helpers
  // =====================
  const updateRFMSettings = (
    settings: any[],
    values: Record<string, any>,
  ): any[] => {
    return settings.map((item) => ({
      ...item,
      RFMStartValue: getParsedValue(values, item, "start"),
      RFMEndValue: getParsedValue(values, item, "end"),
    }));
  };

  const getParsedValue = (
    values: Record<string, any>,
    item: any,
    type: "start" | "end",
  ): number => {
    const parsedValue = parseFloat(
      values[`${item.RFMType}-${item.RFMTier}-${type}`],
    );
    return isNaN(parsedValue) ? 0 : parsedValue;
  };

  const convertBaseRanges = (
    baseRanges: TierData[],
    conversionFactor: number,
  ) => {
    let previousEnd = 0;
    const isAnyDecimal = baseRanges.some((t) => (t.baseEnd ?? 0) % 1 !== 0);

    return baseRanges.map(({ tier, baseStart, baseEnd }, index) => {
      let startValue: number, endValue: number;
      if (tier === 1 && baseEnd === 0) {
        const tier2 = baseRanges.find((t) => t.tier === 2);
        startValue =
          (tier2?.baseEnd ?? 0) / conversionFactor + (isAnyDecimal ? 0.1 : 1);
        endValue = 0;
      } else if (index === 0) {
        startValue = baseStart;
        endValue = baseEnd / conversionFactor;
      } else {
        startValue = previousEnd + (isAnyDecimal ? 0.1 : 1);
        endValue = baseEnd / conversionFactor;
      }

      previousEnd = endValue;
      return { tier, baseStart: startValue, baseEnd: endValue };
    });
  };

  const scaleTiers = (baseRanges: TierData[], scaleFactor: number) => {
    let previousEnd = 0;
    const isAnyDecimal = baseRanges.some((t) => (t.baseEnd ?? 0) % 1 !== 0);

    return baseRanges.map(({ tier, baseStart, baseEnd }, index) => {
      let startValue: number, endValue: number;

      if (tier === 1 && baseEnd === 0) {
        const tier2 = baseRanges.find((t) => t.tier === 2);
        startValue =
          (tier2?.baseEnd ?? 0) * scaleFactor + (isAnyDecimal ? 0.1 : 1);
        endValue = 0;
      } else if (index === 0) {
        startValue = baseStart;
        endValue = baseEnd * scaleFactor;
      } else {
        startValue = previousEnd + (isAnyDecimal ? 0.1 : 1);
        endValue = baseEnd * scaleFactor;
      }

      previousEnd = endValue;
      return { tier, startValue, endValue };
    });
  };

  const getFrequencyTiers = (
    rfmData: any[],
    period: number,
    originalPeriod?: number,
  ): any[] => {
    if (!rfmData || rfmData.length === 0) return [];

    const scaleFactor = period / 3;
    const conversionFactor = originalPeriod ? originalPeriod / 3 : 1;

    let baseRanges: TierData[] = rfmData
      .filter((item) => item.RFMType === 2)
      .sort((a, b) => b.RFMTier - a.RFMTier)
      .map(({ RFMTier, RFMStartValue, RFMEndValue }) => ({
        tier: RFMTier,
        baseStart: RFMStartValue,
        baseEnd: RFMEndValue,
      }));

    if (originalPeriod && originalPeriod !== 3) {
      baseRanges = convertBaseRanges(baseRanges, conversionFactor);
    }

    const scaledTiers = scaleTiers(baseRanges, scaleFactor);

    return rfmData.map((item) => {
      if (item.RFMType === 2) {
        const matchedTier = scaledTiers.find((t) => t.tier === item.RFMTier);
        return {
          ...item,
          RFMStartValue: matchedTier?.startValue ?? item.RFMStartValue,
          RFMEndValue: matchedTier?.endValue ?? item.RFMEndValue,
        };
      }
      return item;
    });
  };

  const columns: ColumnsType<{
    key: string;
    definition: string;
    veryHigh: string;
    high: string;
    medium: string;
    low: string;
    veryLow: string;
  }> = [
    {
      title: "Definition",
      dataIndex: "definition",
      key: "definition",
      fixed: "left",
      width: 150,
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#C9C7C7",
          fontWeight: "bold",
          textAlign: "center",
        },
      }),
      onCell: (value: any) => ({
        style: {
          backgroundColor: "#F2F2F2",
          padding: "12px",
          height: "100%",
        },
      }),
      render: (text: string, record: any) => {
        if (text === "Recency") {
          return (
            <>
              {text}
              <br />
              <span style={{ color: "#888", fontSize: "12px" }}>
                (Last Order)
              </span>
            </>
          );
        } else if (text === "Frequency") {
          return (
            <>
              {text}
              <br />
              <span style={{ color: "#888", fontSize: "12px" }}>
                (Order Count per {selectedPeriod} months)
              </span>
            </>
          );
        } else if (text === "Monetary") {
          return (
            <>
              {text}
              <br />
              <span style={{ color: "#888", fontSize: "12px" }}>
                (Total Spending)
              </span>
            </>
          );
        } else {
          return text;
        }
      },
    },
    {
      title: "Very High",
      dataIndex: "VeryHigh",
      key: "veryHigh",
      width: 180,

      onHeaderCell: () => ({
        style: {
          backgroundColor: "#258FDA",
          fontWeight: "bold",
          textAlign: "center",
        },
      }),
      render: (value, record) => (
        <div style={{ textAlign: "center" }}>
          <div>{value}</div>
          {/* {record.definition === "Frequency" && (
            <div style={{ fontSize: 12, color: "#555" }}>
              every {selectedPeriod} months
            </div>
          )} */}
        </div>
      ),
      onCell: (value: any) => ({
        style: {
          backgroundColor: "#E9F4FB",
          padding: "12px",
          height: "100%",
          fontWeight: value.VeryHigh === "Out Of Range" ? "bold" : "normal",
        },
      }),
    },
    {
      title: "High",
      dataIndex: "High",
      key: "high",
      width: 180,
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#4BB464",
          fontWeight: "bold",
          textAlign: "center",
        },
      }),
      render: (value, record) => (
        <div style={{ textAlign: "center" }}>
          <div>{value}</div>
          {/* {record.definition === "Frequency" && (
            <div style={{ fontSize: 12, color: "#555" }}>
              every {selectedPeriod} months
            </div>
          )} */}
        </div>
      ),
      onCell: (value: any) => ({
        style: {
          backgroundColor: "#EDF8F0",
          padding: "12px",
          height: "100%",
          fontWeight: value.High === "Out Of Range" ? "bold" : "normal",
        },
      }),
    },
    {
      title: "Medium",
      dataIndex: "Medium",
      key: "medium",
      width: 180,
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#FFE500",
          fontWeight: "bold",
          textAlign: "center",
        },
      }),
      render: (value, record) => (
        <div style={{ textAlign: "center" }}>
          <div>{value}</div>
          {/* {record.definition === "Frequency" && (
            <div style={{ fontSize: 12, color: "#555" }}>
              every {selectedPeriod} months
            </div>
          )} */}
        </div>
      ),
      onCell: (value: any) => ({
        style: {
          backgroundColor: "#FFFCE5",
          padding: "12px",
          height: "100%",
          fontWeight: value.Medium === "Out Of Range" ? "bold" : "normal",
        },
      }),
    },
    {
      title: "Low",
      dataIndex: "Low",
      key: "low",
      width: 180,
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#FF9200",
          fontWeight: "bold",
          textAlign: "center",
        },
      }),
      render: (value, record) => (
        <div style={{ textAlign: "center" }}>
          <div>{value}</div>
          {/* {record.definition === "Frequency" && (
            <div style={{ fontSize: 12, color: "#555" }}>
              every {selectedPeriod} months
            </div>
          )} */}
        </div>
      ),
      onCell: (value: any) => ({
        style: {
          backgroundColor: "#FFF4E5",
          padding: "12px",
          height: "100%",
          fontWeight: value.Low === "Out Of Range" ? "bold" : "normal",
        },
      }),
    },
    {
      title: "Very Low",
      dataIndex: "VeryLow",
      key: "veryLow",
      width: 180,
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#D92636",
          fontWeight: "bold",
          textAlign: "center",
        },
      }),
      render: (value, record) => (
        <div style={{ textAlign: "center" }}>
          <div>{value}</div>
          {/* {record.definition === "Frequency" && (
            <div style={{ fontSize: 12, color: "#555" }}>
              every {selectedPeriod} months
            </div>
          )} */}
        </div>
      ),
      onCell: (value: any) => {
        return {
          style: {
            backgroundColor: "#FBE9EB",
            padding: "12px",
            height: "100%",
            fontWeight: value.VeryLow === "Out Of Range" ? "bold" : "normal",
          },
        };
      },
    },
  ];

  const transposedData = [
    {
      key: "VeryHigh",
      definition: "Very High",
      Recency: rfmSettings?.[0]?.VeryHigh ?? "-",
      Frequency: rfmSettings?.[1]?.VeryHigh ?? "-",
      Monetary: rfmSettings?.[2]?.VeryHigh ?? "-",
    },
    {
      key: "High",
      definition: "High",
      Recency: rfmSettings?.[0]?.High ?? "-",
      Frequency: rfmSettings?.[1]?.High ?? "-",
      Monetary: rfmSettings?.[2]?.High ?? "-",
    },
    {
      key: "Medium",
      definition: "Medium",
      Recency: rfmSettings?.[0]?.Medium ?? "-",
      Frequency: rfmSettings?.[1]?.Medium ?? "-",
      Monetary: rfmSettings?.[2]?.Medium ?? "-",
    },
    {
      key: "Low",
      definition: "Low",
      Recency: rfmSettings?.[0]?.Low ?? "-",
      Frequency: rfmSettings?.[1]?.Low ?? "-",
      Monetary: rfmSettings?.[2]?.Low ?? "-",
    },
    {
      key: "VeryLow",
      definition: "Very Low",
      Recency: rfmSettings?.[0]?.VeryLow ?? "-",
      Frequency: rfmSettings?.[1]?.VeryLow ?? "-",
      Monetary: rfmSettings?.[2]?.VeryLow ?? "-",
    },
  ];

  const columnsInTablet: ColumnsType<any> = [
    {
      title: "Definition",
      dataIndex: "definition",
      key: "definition",
      fixed: "left",
      width: 150,
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#C9C7C7",
          fontWeight: "bold",
          textAlign: "center",
        },
      }),
      onCell: (record: any) => ({
        style: {
          backgroundColor:
            record.definition === "Very High"
              ? "#258FDA"
              : record.definition === "High"
                ? "#4BB464"
                : record.definition === "Medium"
                  ? "#FFE500"
                  : record.definition === "Low"
                    ? "#FF9200"
                    : record.definition === "Very Low"
                      ? "#D92636"
                      : "#F2F2F2",
          padding: "12px",
          height: "100%",
          fontWeight: "bold",
        },
      }),
    },
    {
      title: (
        <>
          Recency
          <br />
          <span style={{ fontSize: 12, color: "#555" }}>(Last Order)</span>
        </>
      ),
      dataIndex: "Recency",
      key: "recency",
      width: 180,
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#C9C7C7",
          fontWeight: "bold",
          textAlign: "center",
        },
      }),
      onCell: (record: any) => ({
        style: {
          backgroundColor:
            record.definition === "Very High"
              ? "#E9F4FB"
              : record.definition === "High"
                ? "#EDF8F0"
                : record.definition === "Medium"
                  ? "#FFFCE5"
                  : record.definition === "Low"
                    ? "#FFF4E5"
                    : record.definition === "Very Low"
                      ? "#FBE9EB"
                      : "#F2F2F2",
          padding: "12px",
          height: "100%",
          fontWeight: record.Recency === "Out Of Range" ? "bold" : "unset",
        },
      }),
    },
    {
      title: (
        <>
          Frequency
          <br />
          <span style={{ fontSize: 12, color: "#555" }}>
            (Order Count per {selectedPeriod} months)
          </span>
        </>
      ),
      dataIndex: "Frequency",
      key: "frequency",
      width: 180,
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#C9C7C7",
          fontWeight: "bold",
          textAlign: "center",
        },
      }),
      onCell: (record: any) => ({
        style: {
          backgroundColor:
            record.definition === "Very High"
              ? "#E9F4FB"
              : record.definition === "High"
                ? "#EDF8F0"
                : record.definition === "Medium"
                  ? "#FFFCE5"
                  : record.definition === "Low"
                    ? "#FFF4E5"
                    : record.definition === "Very Low"
                      ? "#FBE9EB"
                      : "#F2F2F2",
          padding: "12px",
          height: "100%",
        },
      }),
      render: (value, record) => (
        <div>
          <div>{value}</div>
          <div style={{ fontSize: "10px", color: "#555" }}>
            every {selectedPeriod} months
          </div>
        </div>
      ),
    },
    {
      title: (
        <>
          Monetary
          <br />
          <span style={{ fontSize: 12, color: "#555" }}>(Total Spending)</span>
        </>
      ),
      dataIndex: "Monetary",
      key: "monetary",
      width: 180,
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#C9C7C7",
          fontWeight: "bold",
          textAlign: "center",
        },
      }),
      onCell: (record: any) => ({
        style: {
          backgroundColor:
            record.definition === "Very High"
              ? "#E9F4FB"
              : record.definition === "High"
                ? "#EDF8F0"
                : record.definition === "Medium"
                  ? "#FFFCE5"
                  : record.definition === "Low"
                    ? "#FFF4E5"
                    : record.definition === "Very Low"
                      ? "#FBE9EB"
                      : "#F2F2F2",
          padding: "12px",
          height: "100%",
        },
      }),
    },
  ];

  // =====================
  // Cards: Member Stats
  // =====================
  const cardData = [
    {
      key: "card-data-1",
      title: "All Total Members",
      value: (countFullPDPAMember + countPartialPDPAMember).toLocaleString(
        "en-US",
      ),
      icon: "/icon/icon-memberlist.svg",
      tooltip: "",
    },
    {
      key: "card-data-2",
      title: "Full PDPA Members",
      value: countFullPDPAMember.toLocaleString("en-US"),
      icon: "/icon/icon-memberlist.svg",
      tooltip:
        "Fully consents under PDPA, allowing their data to be used for marketing, promotions, and personalized engagement.",
    },
    {
      key: "card-data-2",

      title: "Partial PDPA Members",
      value: countPartialPDPAMember.toLocaleString("en-US"),
      icon: "/icon/icon-memberlist-lock.svg",
      tooltip:
        "Consents only to essential data use for orders and support, excluding marketing and promotions.",
    },
  ];

  // =====================
  // Tooltip: RechartsTooltip
  // =====================
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const { SegmentName, Count, SegmentDescription } = payload[0].payload;

      const index = dataSegmentBarChart.findIndex(
        (item: any) => item.SegmentName === SegmentName,
      );

      const getCellColor = (data: any, index: number) => {
        return "#1565C0";
      };

      const tooltipColor = getCellColor(payload[0].payload, index);

      return (
        <Tooltip title={`Segment: ${SegmentName} | Total: ${Count}`}>
          <div
            style={{
              background: "#fff",
              padding: 10,
              border: `1px solid ${tooltipColor}`,
              borderRadius: 4,
            }}>
            <Button
              style={{
                backgroundColor: tooltipColor,
                color: "#fff",
                fontWeight: 600,
              }}>
              <b>{SegmentName}</b>
            </Button>
            <p style={{ color: tooltipColor, margin: 0 }}>
              {SegmentDescription}
            </p>
          </div>
        </Tooltip>
      );
    }
    return null;
  };

  // =====================
  // Event Handlers
  // =====================
  const handleBarClick = async (data: any) => {
    const selectedSegment = segmentOptions.find(
      (option) => Number(option.value) === data.Segment,
    );
    if (selectedSegment) {
      setRfmFilter([selectedSegment.value]);
    }

    if (data.Segment > 0) {
      setSelectedSegment(null);
      setSelectedSegmentId(data.Segment);
    } else {
      setSelectedSegmentId(null);
      setSelectedSegment(data.SegmentName);
    }
  };

  const handleBarRFMClick = (data: any, category: string) => {
    switch (category) {
      case "Recency":
        setRecencyFilter([String(data)]);
        break;
      case "Frequency":
        setFrequencyFilter([String(data)]);
        break;
      case "Monetary":
        setMonetaryFilter([String(data)]);
        break;
      default:
        break;
    }
  };

  const handleChangeCutOffDateInEdit = (value: string) => {
    setIsTyping(false);
    setCutOffDateInEdit(value);
    const selectedOption = optionsCutOffDateOnEdit.find(
      (opt) => opt.value === value,
    );
    setSelectedPeriod(selectedOption?.period ?? 3);
    if (selectedOption) {
      const formValues = form.getFieldsValue();
      const updatedSettings = updateRFMSettings(brandRFMSetting, formValues);
      const { updatedSettings: newRFMSettings, transformedData } =
        applyFrequencyDataUpdate(
          updatedSettings,
          updatedSettings,
          selectedPeriod,
          selectedOption.period,
        );
      setRfmSettings(transformedData);
      setUpdatedBrandRFMSetting(newRFMSettings);
    }
  };

  const handleLoadProfile = (value: any) => {
    const selected =
      rfmProfile.find((item) => item.Id === value) ||
      defaultProfile.find((item) => item.Id === value);

    const { finalProfile, mappedData, newRFMSettings, transformedData } =
      prepareActiveRFMProfile(
        selected,
        defaultProfile,
        brandId ?? "",
        selectedPeriod,
        applyFrequencyDataUpdate,
      );

    setSelectedRFMProfile(finalProfile);
    setBrandRFMSetting(mappedData);
    setRfmSettings(transformedData);
    setUpdatedBrandRFMSetting(newRFMSettings);
    setIsValueChanges(false);
  };

  const categories = ["Recency", "Frequency", "Monetary"];

  const getColorForBar = (entry: any, index: number) => {
    const colors = ["#258FDA", "#4BB464", "#FFE500", "#FF9200", "#D92636"];

    return colors[index % colors.length];
  };

  const roundToNearest = (value: number): number => {
    if (value <= 0) return 0;

    const magnitude = Math.pow(10, Math.floor(Math.log10(value)));
    const base = magnitude / 2;

    return Math.ceil((value + 1) / base) * base;
  };

  // =====================
  // Table: Top Performers
  // =====================
  const columnsTopPerformers = [
    // TESTING PURPOSE
    // {
    //   title: "UserId",
    //   dataIndex: "UserId",
    //   key: "userId",
    //   render: (text: string, record: TopPerformers) => (
    //     <span>{record?.UserId ?? ""}</span>
    //   ),
    // },
    {
      title: "First Name",
      dataIndex: "Firstname",
      key: "firstname",
      render: (text: string, record: TopPerformers) => (
        <span>{record?.FirstName ?? ""}</span>
      ),
    },
    {
      title: "Last Name",
      dataIndex: "LastName",
      key: "lastname",
      render: (text: string, record: TopPerformers) => (
        <span>{record?.LastName ?? ""}</span>
      ),
    },
    {
      title: "Customer Contact",
      dataIndex: "ContactIdd",
      key: "phone",
      render: (text: string, record: TopPerformers) => (
        <span>{text + record.ContactNumber}</span>
      ),
    },
    {
      title: "Email Address",
      dataIndex: "Email",
      key: "email",
      render: (text: string, record: TopPerformers) => <span>{text}</span>,
    },
    {
      title: "Birthday",
      dataIndex: "BirthDate",
      key: "birthDate",
      render: (text: string) => (
        <span>
          {text && moment(text).format("MMM DD, YYYY") !== "Jan 01, 0001"
            ? moment(text).format("YYYY-MM-DD")
            : ""}
        </span>
      ),
    },
    {
      title: "Country Name",
      dataIndex: "CountryName",
      key: "CountryName",
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: "Address",
      dataIndex: "Address",
      key: "Address",
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: "Orders",
      dataIndex: "TotalOrderCount",
      key: "Orders",
      render: (value: number) => (
        <span>{value ? value.toLocaleString("en-US") : 0}</span>
      ),
    },
    {
      title: "Last Order",
      dataIndex: "LastTransactionDate",
      key: "lastOrder",
      render: (text: Date) => (
        <span>
          {text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : "No Orders"}
        </span>
      ),
    },
    {
      title: "Total Order Value",
      dataIndex: "TotalOrderValue",
      key: "monetary",
      render: (value: number) => (
        <span>
          $
          {value
            ? value.toLocaleString("en-US", { minimumFractionDigits: 2 })
            : 0}
        </span>
      ),
    },
    {
      title: "Registration Date",
      dataIndex: "RegistrationDate",
      key: "RegistrationDate",
      render: (value: Date) => (
        <span>{value ? moment(value).format("YYYY-MM-DD") : "No Orders"}</span>
      ),
    },
    {
      title: "Registration Service",
      dataIndex: "RegistrationService",
      key: "RegistrationService",
      render: (value: string) => <span>{value}</span>,
    },
    {
      title: "Recency",
      dataIndex: "RecencyCategory",
      key: "RecencyCategory",
      render: (value: number) => (
        <span>{value ? RFMTierDescriptions[value as RFMTier] : ""}</span>
      ),
    },
    {
      title: "Frequency",
      dataIndex: "FrequencyCategory",
      key: "FrequencyCategory",
      render: (value: number) => (
        <span>{value ? RFMTierDescriptions[value as RFMTier] : ""}</span>
      ),
    },
    {
      title: "Monetary",
      dataIndex: "MonetaryCategory",
      key: "MonetaryCategory",
      render: (value: number) => (
        <span>{value ? RFMTierDescriptions[value as RFMTier] : ""}</span>
      ),
    },
    {
      title: "Segment",
      dataIndex: "PrimarySegmentName",
      key: "segment",
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: "Member Tier",
      dataIndex: "Tier",
      key: "Tier",
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: "Registered Brand",
      dataIndex: "BrandName",
      key: "Brand",
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: "Registered Store",
      dataIndex: "OutletName",
      key: "Store",
      render: (text: string) => <span>{text}</span>,
    },
    ...(filterCampaign !== null && filterCampaign !== undefined
      ? [
          {
            title: "Campaign",
            dataIndex: "IsCampaignCompleted",
            key: "campaign",
            render: (val: boolean | null | undefined) =>
              val === null || val === undefined ? (
                <span></span>
              ) : (
                <span>{val ? "Yes" : "No"}</span>
              ),
          },
        ]
      : []),
    {
      title: "SMS Reward Reminder",
      dataIndex: "SMSRewardReminder",
      key: "SMSRewardReminder",
      render: (text: boolean) => <span>{text ? "Yes" : "No"}</span>,
    },
    {
      title: "Email Reward Reminder",
      dataIndex: "EmailRewardReminder",
      key: "EmailRewardReminder",
      render: (text: boolean) => <span>{text ? "Yes" : "No"}</span>,
    },
    {
      title: "Additional SMS Marketing",
      dataIndex: "AdditionalSMSMarketing",
      key: "AdditionalSMSMarketing",
      render: (text: boolean) => <span>{text ? "Yes" : "No"}</span>,
    },
    {
      title: "Additional Email Marketing",
      dataIndex: "AdditionalEmailMarketing",
      key: "AdditionalEmailMarketing",
      render: (text: boolean) => <span>{text ? "Yes" : "No"}</span>,
    },
    {
      title: "Member Point Balance",
      dataIndex: "Point",
      key: "point",
      render: (value: number) => <span>{value ? value : 0}</span>,
    },
    {
      title: "Member Point Balance Expiring",
      dataIndex: "PointsToBeExpired",
      key: "PointsToBeExpired",
      render: (value: number) => <span>{value ? value : 0}</span>,
    },
    {
      title: "Member Point Balance Expiry Date",
      dataIndex: "PointExpiryDate",
      key: "PointExpiryDate",
      render: (value: Date) => (
        <span>{value ? moment(value).format("YYYY-MM-DD") : ""}</span>
      ),
    },
    {
      title: "Member Balance Voucher",
      dataIndex: "VoucherCount",
      key: "VoucherCount",
      render: (value: number) => <span>{value ? value : 0}</span>,
    },
    {
      title: "Nearest Voucher Expiry Date",
      dataIndex: "NearestVoucherExpiry",
      key: "NearestVoucherExpiry",
      render: (value: Date) => (
        <span>{value ? moment(value).format("YYYY-MM-DD") : ""}</span>
      ),
    },
  ];
  const allKeys = columnsTopPerformers.map((col) => col.key as string);
  const defaultKeys = filterCampaign !== null ? allKeys : allKeys.slice(0, 29);

  const [selectedKeys, setSelectedKeys] = useState<string[]>(defaultKeys);
  const [selectedMobileKeys, setSelectedMobileKeys] =
    useState<string[]>(defaultKeys);

  const options = columnsTopPerformers.map((col) => ({
    label: col.title as string,
    value: col.key as string,
  }));

  const visibleColumns = columnsTopPerformers.filter((col) =>
    selectedKeys.includes(col.key as string),
  );
  // =====================
  // Data Fetching
  // =====================
  const finalRegisteredBrand = selectedRegisteredBrand.includes(AllBrand)
    ? []
    : selectedRegisteredBrand;

  const finalRegisteredStore =
    selectedRegisteredStore.includes(AllStores) ||
    listRegisteredStoreFilter.every((store) =>
      selectedRegisteredStore.includes(store),
    )
      ? []
      : selectedRegisteredStore;

  const finalPurchaseBrand = selectedPurchaseBrand.includes(AllBrand)
    ? []
    : selectedPurchaseBrand;

  const finalPurchaseStore =
    selectedPurchaseStore.includes(AllStores) ||
    listPurchaseStoreFilter.every((store) =>
      selectedPurchaseStore.includes(store),
    )
      ? []
      : selectedPurchaseStore;

  const fetchDashboardData = async () => {
    setLoading(true);

    const periodEnumValue: RFMPeriod = labelToRFMTPeriodMap[labelTimeRange];
    const nextAfterLifetime = rangePresets.filter(
      (x) => !x.disabled && x.label !== "Lifetime",
    )[0];
    const params: DashboardParams = {
      brandId: brandId ?? "",
      selectedSegment: selectedSegment ?? undefined,
      selectedSegmentId: selectedSegmentId ?? undefined,
      startDate:
        isFirstLoad && nextAfterLifetime
          ? nextAfterLifetime.value[0].format("YYYY-MM-DD")
          : placeholder === "Lifetime"
            ? oldest.format("YYYY-MM-DD")
            : rangeValue
              ? rangeValue[0].format("YYYY-MM-DD")
              : moment()
                  .subtract(2, "years")
                  .subtract(1, "day")
                  .format("YYYY-MM-DD"),

      endDate: rangeValue
        ? rangeValue[1].format("YYYY-MM-DD hh:mm:ss")
        : now.format("YYYY-MM-DD hh:mm:ss"),
      periodEnumValue: periodEnumValue?.toString(),
      selectedMembers,
      finalRegisteredBrand,
      finalRegisteredStore,
      finalPurchaseBrand,
      finalPurchaseStore,
      rfmFilter:
        filterMode === "segment"
          ? rfmFilter?.includes("all")
            ? []
            : rfmFilter?.map(Number) || []
          : [],
      recencyFilter:
        filterMode === "criteria"
          ? recencyFilter?.includes("all")
            ? []
            : recencyFilter?.map(Number)
          : [],
      frequencyFilter:
        filterMode === "criteria"
          ? frequencyFilter?.includes("all")
            ? []
            : frequencyFilter?.map(Number)
          : [],
      monetaryFilter:
        filterMode === "criteria"
          ? monetaryFilter?.includes("all")
            ? []
            : monetaryFilter?.map(Number)
          : [],
      campaignFilter: filterCampaign,
    };

    setDashboardParams(params);

    try {
      const data = await dashboardService.getDashboardData(
        params.brandId,
        params.selectedSegment,
        params.selectedSegmentId,
        params.startDate,
        params.endDate,
        params.periodEnumValue,
        Array.isArray(params.selectedMembers)
          ? (params.selectedMembers[0] ?? null)
          : params.selectedMembers,
        params.finalRegisteredBrand,
        params.finalRegisteredStore,
        params.finalPurchaseBrand,
        params.finalPurchaseStore,
        params.rfmFilter,
        params.recencyFilter,
        params.frequencyFilter,
        params.monetaryFilter,
        params.campaignFilter,
      );
      setDataBarChart(
        (data.RFM || []).sort(
          (a: RFMData, b: RFMData) => Number(a.RFMTier) - Number(b.RFMTier),
        ),
      );
      setCardSegmentCountData(
        (data.MemberSegment || []).filter((segment: any) =>
          [-2, -3, -4].includes(segment.Segment),
        ),
      );
      setDataSegmentBarChart(
        (data.MemberSegment || []).sort((a: any, b: any) => {
          const order: Record<string, number> = {
            "-2": 1,
            "-3": 2,
            "-4": 3,
          };

          const getOrder = (segment: number) => {
            const segmentStr = segment.toString();
            if (order.hasOwnProperty(segmentStr)) return order[segmentStr];

            if (segment === -1) return Infinity - 1;
            if (segment === 0) return Infinity;

            if (segment > 0) return segment + 1000;
            return segment + 100;
          };

          return getOrder(a.Segment) - getOrder(b.Segment);
        }),
      );

      setDataTopPerformers(data.TopPerformers || []);
      setCountPartialPDPAMember(data.Member.PartialPDPACount ?? 0);
      setCountFullPDPAMember(data.Member.FullPDPACount ?? 0);
      setCountMemberFilter(data.TotalMemberFilter ?? 0);
      if (
        listRegisteredBrandFilter.length === 0 ||
        listRegisteredStoreFilter.length === 0 ||
        listBrandStore.length === 0
      ) {
        setListBrandStore(
          (data.ListAccountBrand || [])
            .map((item: any) => ({
              BrandName: item.BrandName?.trim() || null,
              OutletName: item.OutletName?.trim() || null,
            }))
            .filter(
              (item: any) =>
                item.BrandName &&
                item.BrandName !== "" &&
                item.OutletName &&
                item.OutletName !== "",
            ),
        );
        setListRegisteredBrandFilter(
          Array.from(
            new Set(
              data.ListAccountBrand.map((s: any) => s.BrandName?.trim()).filter(
                (name: any) => name && name !== "",
              ),
            ),
          ).sort((a: any, b: any) => a.localeCompare(b)),
        );

        setListPurchaseBrandFilter(
          Array.from(
            new Set(
              data.ListAccountBrand.map((s: any) => s.BrandName?.trim()).filter(
                (name: any) => name && name !== "",
              ),
            ),
          ).sort((a: any, b: any) => a.localeCompare(b)),
        );

        setListRegisteredStoreFilter(
          Array.from(
            new Set(
              data.ListAccountBrand.map((s: any) =>
                s.OutletName?.trim(),
              ).filter((name: any) => name && name !== ""),
            ),
          ).sort((a: any, b: any) => a.localeCompare(b)),
        );

        setListPurchaseStoreFilter(
          Array.from(
            new Set(
              data.ListAccountBrand.map((s: any) =>
                s.OutletName?.trim(),
              ).filter((name: any) => name && name !== ""),
            ),
          ).sort((a: any, b: any) => a.localeCompare(b)),
        );
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setIsFirstLoad(false);
      setLoading(false);
    }
  };

  const fetchListCampaign = async () => {
    if (!brandId) return;

    try {
      const listCampaign = await campaignService.getAllCampaign();
      setListCampaign(listCampaign);
    } catch (error) {
      console.error("Error fetching BrandRFMProfile:", error);
    }
  };

  const fetchBrandRFMProfile = async () => {
    if (!brandId) return;

    try {
      const listProfile =
        await brandRFMProfileService.getBrandRFMProfile(brandId);
      const validProfiles = Array.isArray(listProfile) ? listProfile : [];
      setRfmProfile(validProfiles);

      const activeProfile = validProfiles.find((profile) => profile.IsActive);

      if (!activeProfile) return;

      const { finalProfile, mappedData, newRFMSettings, transformedData } =
        prepareActiveRFMProfile(
          activeProfile,
          defaultProfile,
          brandId,
          selectedPeriod,
          applyFrequencyDataUpdate,
        );
      setSelectedRFMProfile(finalProfile);
      setBrandRFMSetting(mappedData);
      setRfmSettings(transformedData);
      setUpdatedBrandRFMSetting(newRFMSettings);
    } catch (error) {
      console.error("Error fetching BrandRFMProfile:", error);
    }
  };

  const fetchRFMSettings = async () => {
    try {
      if (!brandId) return;
      if (hasFetched.current) return;
      hasFetched.current = true;
      const response =
        await brandRFMSettingService.getBrandRFMSettings(brandId);
      const data: any[] = Array.isArray(response) ? response : [];
      const sortedData = data.sort(
        (a, b) => (b.RFMTier || 0) - (a.RFMTier || 0),
      );

      setBrandRFMSetting(Array.isArray(sortedData) ? sortedData : []);

      const { updatedSettings: newRFMSettings, transformedData } =
        applyFrequencyDataUpdate(sortedData, sortedData, selectedPeriod);

      setRfmSettings(transformedData);

      setUpdatedBrandRFMSetting(newRFMSettings);
    } catch (error) {
      console.error("Error fetching RFM settings:", error);
    }
  };

  const fetchOldestMemberSignup = async () => {
    try {
      if (!brandId) return;

      const response = await dashboardService.getOldestMemberSignup(brandId);
      setOldestDate(response.Date);
      const bestLabel = getBestPresetLabel(response.Date);
      setLabelTimeRange(bestLabel);
      const preset = rawPresets.find((p) => p.label === bestLabel);

      if (preset) {
        setRangeValue(preset.getRange());
      }
    } catch (error) {
      console.error("Error fetching oldest member signup :", error);
    }
  };

  const defaultSettings = async (brandId: string) => {
    const setting =
      await brandRFMSettingService.getDefaultBrandRFMSetting(brandId);
    return setting ?? null;
  };

  // =====================
  // Initial Form Values
  // =====================

  const initialValues = useMemo(() => {
    return getFrequencyTiers(brandRFMSetting, selectedPeriod).reduce(
      (acc, item) => {
        acc[`${item.RFMType}-${item.RFMTier}-start`] =
          item.RFMStartValue === 0 ? "" : item.RFMStartValue;
        acc[`${item.RFMType}-${item.RFMTier}-end`] =
          item.RFMEndValue === 0 ? "" : item.RFMEndValue;
        return acc;
      },
      {} as Record<string, any>,
    );
  }, [brandRFMSetting]);

  // =====================
  // Reset Brand RFM Settings
  // =====================
  const resetBrandRFMSettings = async () => {
    try {
      if (!brandId) return;
      await brandRFMSettingService.resetBrandRFMSettings(brandId);
      hasFetched.current = false;
      await fetchDashboardData();
      setIsUpdateDefaultModalSuccessVisible(true);
      setIsConfirmationModalVisible(false);

      resetEditForm(false);
      fetchBrandRFMProfile();
    } catch (error) {
      console.error("Error fetching RFM settings:", error);
    }
  };

  // =====================
  // Download section
  // =====================

  const downloadTopPerformers = async () => {
    try {
      setLoading(true);
      if (!brandId) return;

      const fromDate = rangeValue
        ? rangeValue[0].format("YYYY-MM-DD")
        : moment().subtract(2, "years").subtract(1, "day").format("YYYY-MM-DD");

      const toDate = rangeValue
        ? rangeValue[1].format("YYYY-MM-DD HH:mm:ss")
        : now.format("YYYY-MM-DD HH:mm:ss");

      const response = await dashboardService.getMember(
        dashboardParams.brandId,
        dashboardParams.selectedSegment,
        dashboardParams.selectedSegmentId,
        dashboardParams.startDate,
        dashboardParams.endDate,
        dashboardParams.periodEnumValue,
        Array.isArray(dashboardParams.selectedMembers)
          ? (dashboardParams.selectedMembers[0] ?? null)
          : dashboardParams.selectedMembers,
        dashboardParams.finalRegisteredBrand,
        dashboardParams.finalRegisteredStore,
        dashboardParams.finalPurchaseBrand,
        dashboardParams.finalPurchaseStore,
        includeVoucherData ?? false,
        includePointBalance ?? false,
        dashboardParams.rfmFilter,
        dashboardParams.recencyFilter,
        dashboardParams.frequencyFilter,
        dashboardParams.monetaryFilter,
        dashboardParams.campaignFilter,
      );
      const blob = new Blob([response.data], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Members_${fromDate}_${toDate.split(" ")[0]}.xlsx`;
      link.click();
    } catch (error) {
      console.error("Download error:", error);
      alert("An error occurred while generating Excel.");
    } finally {
      setLoading(false);
    }
  };

  // =====================
  // Compare Active Setting with Default Setting
  // =====================

  const handleChangeMemberFilter = async (values: number | null) => {
    setSelectedMembers(values);
  };

  const handleChangePurchaseBrand = (values: string[]) => {
    let updatedSelectedBrand: string[];

    if (
      values.includes(AllBrand) &&
      !selectedPurchaseBrand.includes(AllBrand)
    ) {
      updatedSelectedBrand = [AllBrand, ...listPurchaseBrandFilter];
    } else if (
      !values.includes(AllBrand) &&
      selectedPurchaseBrand.includes(AllBrand)
    ) {
      updatedSelectedBrand = [];
    } else {
      const allSelected = listPurchaseBrandFilter.every((s) =>
        values.includes(s),
      );
      if (allSelected && !values.includes(AllBrand)) {
        updatedSelectedBrand = [AllBrand, ...listPurchaseBrandFilter];
      } else {
        updatedSelectedBrand = values.filter((v) => v !== AllBrand);
      }
    }

    setSelectedPurchaseBrand(updatedSelectedBrand);

    const relatedStores = listBrandStore
      .filter(
        (s) =>
          s.BrandName &&
          s.BrandName.trim() !== "" &&
          updatedSelectedBrand.includes(s.BrandName),
      )
      .map((s) => s.OutletName?.trim())
      .filter(
        (name, index, self) =>
          name && name !== "" && self.indexOf(name) === index,
      )
      .sort((a, b) => a.localeCompare(b));

    const finalStores =
      relatedStores.length > 0
        ? relatedStores
        : Array.from(
            new Set(
              listBrandStore
                .map((s) => s.OutletName?.trim())
                .filter((name) => name && name !== ""),
            ),
          ).sort((a, b) => a.localeCompare(b));

    setListPurchaseStoreFilter(finalStores);
  };

  const handleChangeRegisteredBrand = (values: string[]) => {
    let updatedSelectedBrand: string[];

    if (
      values.includes(AllBrand) &&
      !selectedRegisteredBrand.includes(AllBrand)
    ) {
      updatedSelectedBrand = [AllBrand, ...listRegisteredBrandFilter];
    } else if (
      !values.includes(AllBrand) &&
      selectedRegisteredBrand.includes(AllBrand)
    ) {
      updatedSelectedBrand = [];
    } else {
      const allSelected = listRegisteredBrandFilter.every((s) =>
        values.includes(s),
      );
      if (allSelected && !values.includes(AllBrand)) {
        updatedSelectedBrand = [AllBrand, ...listRegisteredBrandFilter];
      } else {
        updatedSelectedBrand = values.filter((v) => v !== AllBrand);
      }
    }

    setSelectedBrand(updatedSelectedBrand);

    const relatedStores = listBrandStore
      .filter(
        (s) =>
          s.BrandName &&
          s.BrandName.trim() !== "" &&
          updatedSelectedBrand.includes(s.BrandName),
      )
      .map((s) => s.OutletName?.trim())
      .filter(
        (name, index, self) =>
          name && name !== "" && self.indexOf(name) === index,
      )
      .sort((a, b) => a.localeCompare(b));

    const finalStores =
      relatedStores.length > 0
        ? relatedStores
        : Array.from(
            new Set(
              listBrandStore
                .map((s) => s.OutletName?.trim())
                .filter((name) => name && name !== ""),
            ),
          ).sort((a, b) => a.localeCompare(b));

    setListRegisteredStoreFilter(finalStores);
  };

  const handleChangeRegisteredStore = async (values: string[]) => {
    if (
      values.includes(AllStores) &&
      !selectedRegisteredStore.includes(AllStores)
    ) {
      return setSelectedStore([AllStores, ...listRegisteredStoreFilter]);
    }

    if (
      !values.includes(AllStores) &&
      selectedRegisteredStore.includes(AllStores)
    ) {
      return setSelectedStore([]);
    }

    const allSelected = listRegisteredStoreFilter.every((s) =>
      values.includes(s),
    );
    if (allSelected && !values.includes(AllStores)) {
      return setSelectedStore([AllStores, ...listRegisteredStoreFilter]);
    }

    setSelectedStore(values.filter((v) => v !== AllStores));
  };

  const handleChangePurchaseStore = async (values: string[]) => {
    if (
      values.includes(AllStores) &&
      !selectedPurchaseStore.includes(AllStores)
    ) {
      return setSelectedPurchaseStore([AllStores, ...listPurchaseStoreFilter]);
    }

    if (
      !values.includes(AllStores) &&
      selectedPurchaseStore.includes(AllStores)
    ) {
      return setSelectedPurchaseStore([]);
    }

    const allSelected = listRegisteredStoreFilter.every((s) =>
      values.includes(s),
    );
    if (allSelected && !values.includes(AllStores)) {
      return setSelectedPurchaseStore([
        AllStores,
        ...listRegisteredStoreFilter,
      ]);
    }

    setSelectedPurchaseStore(values.filter((v) => v !== AllStores));
  };

  const applyAllFilter = () => {
    const newPayload = {
      filterMode,
      segmentIds:
        filterMode === "segment"
          ? rfmFilter && !rfmFilter.includes("all")
            ? rfmFilter.map(Number)
            : []
          : [],

      recencyIds:
        filterMode === "criteria"
          ? recencyFilter && !recencyFilter.includes("all")
            ? recencyFilter.map(Number)
            : []
          : [],

      frequencyIds:
        filterMode === "criteria"
          ? frequencyFilter && !frequencyFilter.includes("all")
            ? frequencyFilter.map(Number)
            : []
          : [],

      monetaryIds:
        filterMode === "criteria"
          ? monetaryFilter && !monetaryFilter.includes("all")
            ? monetaryFilter.map(Number)
            : []
          : [],
    };

    setAppliedFilters(newPayload);
  };

  const cancelFilterColumn = () => {
    setSelectedMobileKeys(selectedKeys);
    setIsModalColumnVisible(false);
  };

  const applyFilterColumn = () => {
    setSelectedKeys(selectedMobileKeys);
    setIsModalColumnVisible(false);
  };

  return (
    <>
      {/* {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Spin size="large" tip="Loading data..." />
        </div>
      )}{" "} */}
      <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
        <Col xs={10} md={14} xl={12}>
          <span style={{ fontSize: 16 }}>Members Overview</span>
        </Col>

        <Col xs={14} md={10} xl={12} style={{ textAlign: "right" }}>
          <Button
            type="primary"
            style={{
              backgroundColor: "#E9F4FB",
              color: "#1565C0",
              fontSize: isMobile ? "10px" : "unset",
            }}>
            Last Update:{" "}
            <strong>
              {moment().subtract(1, "days").format("YYYY-MM-DD")} 23:59:59
            </strong>
          </Button>
        </Col>
      </Row>
      <Card style={{ width: "100%" }}>
        <Form layout="vertical">
          <Row gutter={[16, 16]} className="row-section-filter">
            {/* Members */}
            <Col xs={24} sm={24} md={8} lg={8}>
              <Form.Item label="Members">
                <Select<number | null>
                  value={selectedMembers}
                  onChange={handleChangeMemberFilter}>
                  <Option value={null}>All Total Members</Option>
                  <Option value="1">Full PDPA Members</Option>
                  <Option value="2">Partial PDPA Members</Option>
                </Select>
              </Form.Item>
            </Col>

            {/* Registered Brand */}
            <Col xs={24} sm={24} md={8} lg={8}>
              <Form.Item label="Registered Brand">
                <Select
                  mode="multiple"
                  value={
                    selectedRegisteredBrand.includes(AllBrand)
                      ? [AllBrand, ...listRegisteredBrandFilter]
                      : selectedRegisteredBrand
                  }
                  onChange={handleChangeRegisteredBrand}
                  placeholder="Select Brands"
                  maxTagCount={0}
                  maxTagPlaceholder={() =>
                    selectedRegisteredBrand.includes(AllBrand)
                      ? AllBrand
                      : `${selectedRegisteredBrand.length}/${listRegisteredBrandFilter.length} selected`
                  }
                  removeIcon={null}>
                  <Option key={AllBrand} value={AllBrand}>
                    {AllBrand}
                  </Option>
                  {listRegisteredBrandFilter?.map((BrandName) => (
                    <Option key={BrandName} value={BrandName}>
                      {BrandName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            {/* Registered Store */}
            <Col xs={24} sm={24} md={8} lg={8}>
              <Form.Item label="Registered Store">
                <Select
                  mode="multiple"
                  value={
                    selectedRegisteredStore.includes(AllStores)
                      ? [AllStores, ...listRegisteredStoreFilter]
                      : selectedRegisteredStore
                  }
                  onChange={handleChangeRegisteredStore}
                  placeholder="Select Store"
                  maxTagCount={0}
                  maxTagPlaceholder={() =>
                    selectedRegisteredStore.includes(AllStores)
                      ? AllStores
                      : `${selectedRegisteredStore.length}/${listRegisteredStoreFilter.length} selected`
                  }
                  removeIcon={null}>
                  <Option key={AllStores} value={AllStores}>
                    {AllStores}
                  </Option>
                  {listRegisteredStoreFilter?.map((store) => (
                    <Option key={store} value={store}>
                      {store}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            {/* Purchase Brand */}
            <Col xs={24} sm={24} md={8} lg={8}>
              <Form.Item label="Purchase Brand">
                <Select
                  mode="multiple"
                  value={
                    selectedPurchaseBrand.includes(AllBrand)
                      ? [AllBrand, ...listPurchaseBrandFilter]
                      : selectedPurchaseBrand
                  }
                  onChange={handleChangePurchaseBrand}
                  placeholder="Select Brands"
                  maxTagCount={0}
                  maxTagPlaceholder={() =>
                    selectedPurchaseBrand.includes(AllBrand)
                      ? AllBrand
                      : `${selectedPurchaseBrand.length}/${listPurchaseBrandFilter.length} selected`
                  }
                  removeIcon={null}>
                  <Option key={AllBrand} value={AllBrand}>
                    {AllBrand}
                  </Option>
                  {listPurchaseBrandFilter?.map((BrandName) => (
                    <Option key={BrandName} value={BrandName}>
                      {BrandName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            {/* Purchase Store */}
            <Col xs={24} sm={24} md={8} lg={8}>
              <Form.Item label="Purchase Store">
                <Select
                  mode="multiple"
                  value={
                    selectedPurchaseStore.includes(AllStores)
                      ? [AllStores, ...listPurchaseStoreFilter]
                      : selectedPurchaseStore
                  }
                  onChange={handleChangePurchaseStore}
                  placeholder="Select Store"
                  maxTagCount={0}
                  maxTagPlaceholder={() =>
                    selectedPurchaseStore.includes(AllStores)
                      ? AllStores
                      : `${selectedPurchaseStore.length}/${listPurchaseStoreFilter.length} selected`
                  }
                  removeIcon={null}>
                  <Option key={AllStores} value={AllStores}>
                    {AllStores}
                  </Option>
                  {listPurchaseStoreFilter?.map((store) => (
                    <Option key={store} value={store}>
                      {store}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8}>
              <Form.Item label=" ">
                <Button
                  type="primary"
                  style={{ width: "100%" }}
                  onClick={applyAllFilter}>
                  Apply Filter
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
      <Row style={{ marginTop: 20 }}>
        {cardData.map((item, index) => {
          const isFirst = index % 3 === 0;
          const isLast = index % 3 === 2;

          return (
            <Col
              md={8}
              xl={8}
              key={index}
              className="w-100"
              style={{
                paddingLeft: isMobile || isTablet ? 0 : isFirst ? 0 : 8,
                paddingRight: isMobile || isTablet ? 0 : isLast ? 0 : 8,
                marginBottom: isMobile && !isLast ? 20 : 0,
              }}>
              <Card className="card-member">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    height: 70,
                  }}>
                  <div>
                    <div
                      style={{
                        fontSize: 16,
                        lineHeight: "1.2",
                      }}>
                      {item.title}
                      {item.tooltip && (
                        <Tooltip title={item.tooltip}>
                          <InfoCircleOutlined
                            style={{
                              fontSize: 14,
                              marginLeft: 6,
                              color: "#888",
                            }}
                          />
                        </Tooltip>
                      )}
                    </div>
                    <div style={{ fontSize: 24, fontWeight: 700 }}>
                      {item.value}
                    </div>
                  </div>
                  <img src={item.icon} alt="icon" width="30" height="30" />
                </div>
              </Card>
            </Col>
          );
        })}
      </Row>
      <Card
        title={
          <Row
            justify="space-between"
            align="middle"
            wrap
            style={{ width: "100%" }}>
            <Col xs={11} md={12} xl={12}>
              <span
                style={{
                  fontWeight: 600,
                  fontSize: 16,
                  display: "block",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}>
                {`Criteria RFM Table`}
              </span>
            </Col>
            <Col xs={13} md={12} xl={12} style={{ textAlign: "right" }}>
              <Button
                className="button-edit"
                icon={<EditOutlined />}
                color="primary"
                variant="outlined"
                style={{ width: isMobile ? 150 : 210 }}
                onClick={() => setIsEditModalVisible(true)}>
                Edit RFM Criteria
              </Button>
            </Col>
          </Row>
        }
        style={{ width: "100%", marginTop: 20 }}>
        {isTablet || isMobile ? (
          <Table
            className="criteria-table"
            columns={columnsInTablet}
            dataSource={transposedData}
            pagination={false}
            scroll={{ x: "max-content" }}
          />
        ) : (
          <Table
            className="criteria-table"
            columns={columns}
            dataSource={rfmSettings}
            pagination={false}
            scroll={{ x: "max-content" }}
          />
        )}
      </Card>
      <Card title="" style={{ width: "100%", marginTop: 20 }}>
        <Row justify={"space-between"}>
          <Col xs={24} sm={12} md={12} lg={6} xl={6}>
            <div>
              <div style={{ fontSize: 16, fontWeight: 700 }}>
                Select RFM Analysis Period
              </div>
              <div style={{ color: "#636A79", marginTop: 4, fontSize: 12 }}>
                Adjust the period for required RFM analysis and download
              </div>
            </div>
          </Col>
          <Col xs={24} sm={12} md={12} lg={16} xl={16}>
            <Button
              size={"large"}
              onClick={showModalSelectedPeriod}
              style={{
                marginTop: 5,
                padding: "0px",
                fontSize: !isMobile ? 16 : 12,
              }}>
              <span style={{ fontWeight: 700, padding: "0px 0px 0px 15px" }}>
                {placeholder}
              </span>
              (
              {placeholder !== "Lifetime"
                ? rangeValue?.[0].format("YYYY-MM-DD")
                : "Entire Period"}{" "}
              - {rangeValue?.[1].format("YYYY-MM-DD")})
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "0px 4px 0px 4px",
                  marginLeft: 8,
                  padding: "4px 8px",
                  height: "100%",
                }}>
                <i className="icon-calendar"></i>
              </div>
            </Button>
            <Modal
              title={
                <div style={{ textAlign: "center" }}>
                  Select RFM Analysis Period
                </div>
              }
              open={isModalSelectedPeriodVisible}
              onCancel={closeModalSelectedPeriod}
              closable={false}
              style={{
                top: 20,
              }}
              wrapClassName="modal-period"
              footer={[
                <Row style={{ width: "100%" }} key="footer">
                  <Col span={12} style={{ paddingRight: "8px" }}>
                    <Button
                      onClick={handleCancelPeriod}
                      size="middle"
                      type="default"
                      style={{ height: 40, width: "100%" }}>
                      Cancel
                    </Button>
                  </Col>
                  <Col span={12} style={{ paddingLeft: "8px" }}>
                    <Button
                      type="primary"
                      onClick={handleChangePeriod}
                      size="middle"
                      disabled={dateError !== null}
                      style={{ height: 40, width: "100%" }}>
                      Apply
                    </Button>
                  </Col>
                </Row>,
              ]}>
              <List
                dataSource={rangePresets}
                renderItem={(preset: any) => (
                  <List.Item
                    onClick={() => {
                      if (!preset.disabled) {
                        handlePresetClick(preset);
                      }
                    }}
                    style={{
                      display: preset.disabled ? "none" : "flex",
                      cursor: preset.disabled ? "not-allowed" : "pointer",
                      padding: 12,
                      opacity: preset.disabled ? 0.5 : 1,
                    }}>
                    <span
                      style={{
                        color:
                          labelTimeRange === preset.label
                            ? "#1565C0"
                            : preset.disabled
                              ? "#aaa"
                              : "black",
                        fontWeight:
                          labelTimeRange === preset.label ? "bold" : "",
                      }}>
                      {preset.label}
                    </span>
                    {preset.label !== "Custom Range" && (
                      <div
                        style={{
                          fontSize: 12,
                          color:
                            labelTimeRange === preset.label
                              ? "#1565C0"
                              : "#888",
                        }}>
                        {preset.label !== "Lifetime"
                          ? preset.value[0].format("YYYY-MM-DD")
                          : "Entire Period"}{" "}
                        → {preset.value[1].format("YYYY-MM-DD")}
                      </div>
                    )}
                  </List.Item>
                )}
              />

              {labelTimeRange === "Custom Range" && (
                <Row gutter={[16, 16]} style={{ marginTop: 15 }}>
                  <Col span={11}>
                    <DatePicker
                      inputReadOnly
                      suffixIcon={<i className="icon-calendar"></i>}
                      onChange={(date) => {
                        if (date && pickerValue) {
                          const endDate = pickerValue[1];
                          if (endDate) {
                            if (date.isAfter(endDate, "day")) {
                              setDateError(
                                "Start date must be earlier than end date.",
                              );
                            }
                            // else if (date.add(3, "month").isAfter(endDate)) {
                            //   setDateError("Minimum date range is 3 months.");
                            // }
                            else {
                              setDateError(null);
                            }
                          }
                          setPickerValue([date, endDate]);
                        }
                      }}
                      allowClear={false}
                      style={{ width: "100%" }}
                      value={pickerValue?.[0]}
                      placement="bottomLeft"
                      placeholder="Start Date"
                      disabledDate={(current) => {
                        const isFuture =
                          current && current.isAfter(dayjs(), "day");
                        const isBeforeOldest =
                          oldest &&
                          oldest.isValid() &&
                          current &&
                          current.isBefore(oldest, "day");
                        return isFuture || isBeforeOldest;
                      }}
                      disabled={labelTimeRange !== "Custom Range"}
                      getPopupContainer={(trigger) =>
                        trigger.parentElement as HTMLElement
                      }
                    />
                  </Col>
                  <Col
                    span={2}
                    style={{ display: "flex", verticalAlign: "middle" }}>
                    <ArrowRightOutlined />
                  </Col>
                  <Col span={11}>
                    <DatePicker
                      inputReadOnly
                      suffixIcon={<i className="icon-calendar"></i>}
                      allowClear={false}
                      style={{ width: "100%" }}
                      value={pickerValue?.[1]}
                      onChange={(date) => {
                        if (date && pickerValue) {
                          const startDate = pickerValue[0];
                          if (startDate) {
                            if (date.isBefore(startDate, "day")) {
                              setDateError(
                                "Start date must be earlier than end date.",
                              );
                            }
                            // else if (
                            //   startDate.add(3, "month").isAfter(date)
                            // ) {
                            //   setDateError("Minimum date range is 3 months.");
                            // }
                            else {
                              setDateError(null);
                            }
                          }
                          setPickerValue([startDate, date]);
                        }
                      }}
                      placement="bottomLeft"
                      placeholder="End Date"
                      getPopupContainer={(trigger) =>
                        trigger.parentElement as HTMLElement
                      }
                      disabled={labelTimeRange !== "Custom Range"}
                      disabledDate={(current) => {
                        return current && current.isAfter(dayjs(), "day");
                      }}
                    />
                  </Col>
                </Row>
              )}
              {dateError && (
                <div
                  style={{ color: "red", marginTop: 8, textAlign: "center" }}>
                  {dateError}
                </div>
              )}
            </Modal>
          </Col>
        </Row>
      </Card>
      <Row>
        {categories.map((category, index) => {
          const filteredData = dataBarChart.filter(
            (d) => d.RFMType === category,
          );
          const isFirst = index % 3 === 0;
          const isLast = index % 3 === 2;
          return (
            <Col
              xl={8}
              md={24}
              key={category}
              className="w-100"
              style={{
                marginTop: 20,
                paddingLeft: isMobile || isTablet ? 0 : isFirst ? 0 : 8,
                paddingRight: isMobile || isTablet ? 0 : isLast ? 0 : 8,
              }}>
              <Card
                title={
                  <>
                    <span>{category} Value</span>
                  </>
                }>
                <ResponsiveContainer width="100%" height={250}>
                  <BarChart
                    data={filteredData}
                    style={{ cursor: "pointer" }}
                    onClick={(data: any) =>
                      handleBarRFMClick(
                        data?.activePayload[0].payload?.RFMTier,
                        category,
                      )
                    }>
                    <XAxis tick={false} tickLine={false} />
                    <YAxis
                      style={{ cursor: "default" }}
                      tickFormatter={(value) => value.toLocaleString("en-US")}
                      domain={[
                        0,
                        (dataMax: number) =>
                          roundToNearest(dataMax) + roundToNearest(dataMax / 2),
                      ]}
                    />
                    <RechartsTooltip
                      content={({ payload }) => {
                        if (!payload || payload.length === 0) return null;
                        const data = payload[0].payload;
                        return (
                          <div
                            style={{
                              background: "white",
                              padding: "5px",
                              borderRadius: "5px",
                            }}>
                            <Button
                              style={{
                                fontWeight: "bold",
                                backgroundColor: getColorForBar(
                                  data,
                                  data.RFMTier - 1,
                                ),
                              }}>
                              {RFMTierDescriptions[data.RFMTier as RFMTier]}
                            </Button>
                            <p>
                              Total Members:{" "}
                              {data.Count.toLocaleString("en-US")}
                            </p>
                          </div>
                        );
                      }}
                      labelFormatter={(_, test: any) => test.Description}
                    />
                    <Legend
                      style={{ cursor: "default !important" }}
                      content={({ payload }) => {
                        return (
                          <ul
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              flexWrap: "wrap",
                              justifyContent: "center",
                              alignItems: "center",
                              paddingLeft: 0,
                              marginBottom: 0,
                              listStyle: "none",
                              cursor: "default",
                            }}>
                            {filteredData.map((entry, index) => (
                              <li
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: 20,
                                  marginBottom: 8,
                                }}>
                                <div
                                  style={{
                                    width: 16,
                                    height: 16,
                                    backgroundColor: getColorForBar(
                                      entry,
                                      index,
                                    ),
                                    marginRight: 8,
                                  }}
                                />
                                <span style={{ fontSize: "10px" }}>
                                  {entry.Description}
                                </span>
                              </li>
                            ))}
                          </ul>
                        );
                      }}
                    />

                    <Bar dataKey="Count" barSize={40}>
                      {filteredData.map((entry, index) => (
                        <Cell key={index} fill={getColorForBar(entry, index)} />
                      ))}
                      <LabelList
                        dataKey="Count"
                        position="top"
                        formatter={(value: number) =>
                          value.toLocaleString("en-US")
                        }
                      />
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </Card>
            </Col>
          );
        })}
      </Row>
      <Row style={{ marginTop: "20px" }}>
        <Col xs={24} sm={24} lg={24} md={24}>
          <Card
            title={
              <Row
                justify="space-between"
                align="middle"
                wrap
                style={{ width: "100%" }}>
                <Col xs={11} md={12} xl={12}>
                  <span
                    style={{
                      fontWeight: 600,
                      fontSize: 16,
                      display: "block",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                    }}>
                    {`Member Segment`}
                  </span>
                </Col>
                <Col xs={13} md={12} xl={12} style={{ textAlign: "right" }}>
                  <Button
                    color="primary"
                    variant="outlined"
                    className="button-edit"
                    style={{ width: isMobile ? 150 : 210 }}
                    icon={<EditOutlined />}
                    onClick={() =>
                      navigate(
                        `${RoutePaths.IFRAMECOMBINATIONRFM}${location.search}`,
                      )
                    }>
                    Edit RFM Segment
                  </Button>
                </Col>
              </Row>
            }>
            <Row style={{ width: "100%" }}>
              {cardSegmentCountData.map((item, index) => {
                const buttonStyles = [
                  {
                    backgroundColor: "#E7EFF9",
                    color: "#1565C0",
                    fontWeight: 600,
                    cursor: "not-allowed",
                    width: 200,
                  },
                  {
                    backgroundColor: "#E7EFF9",
                    color: "#1565C0",
                    fontWeight: 600,
                    cursor: "not-allowed",
                    width: 200,
                  },
                  {
                    backgroundColor: "#E7EFF9",
                    color: "#1565C0",
                    fontWeight: 600,
                    cursor: "not-allowed",
                    width: 200,
                  },
                ];
                const isFirst = index % 3 === 0;
                const isLast = index % 3 === 2;

                return (
                  <Col
                    xl={8}
                    md={24}
                    xs={24}
                    key={index}
                    style={{
                      paddingLeft: isMobile || isTablet ? 0 : isFirst ? 0 : 8,
                      paddingRight: isMobile || isTablet ? 0 : isLast ? 0 : 8,
                      marginBottom: (isMobile || isTablet) && !isLast ? 5 : 0,
                    }}>
                    <Card>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: 50,
                        }}>
                        <div>
                          <Button
                            style={buttonStyles[index % buttonStyles.length]}>
                            {item.SegmentName}
                          </Button>
                          <div
                            style={{
                              fontSize: 11,
                              height: 32,
                              overflow: "hidden",
                            }}>
                            {item.SegmentDescription.replace(
                              /\d+(\.\d+)?/g,
                              (match) => {
                                const num = parseFloat(match);

                                return isNaN(num)
                                  ? match
                                  : num.toLocaleString("en-US");
                              },
                            )}
                            {/* {!isMobile && !isTablet && <br />} */}
                            {Number(item.Segment) === -3 ? (
                              <span> every 3 months</span>
                            ) : (
                              <span> &nbsp;</span>
                            )}
                          </div>
                        </div>
                        <span style={{ fontSize: 20, fontWeight: "600" }}>
                          {item.Count.toLocaleString("en-US")}
                        </span>
                      </div>
                    </Card>
                  </Col>
                );
              })}
            </Row>
            <Divider />
            <div
              style={{
                width: "100%",
                minHeight: "400px",
                height: Math.max(400, dataSegmentBarChart.length * 40),
              }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart
                  style={{ cursor: "pointer" }}
                  layout="vertical"
                  data={dataSegmentBarChart}
                  margin={{ top: 10, right: 20, left: 15, bottom: 10 }}
                  onClick={(event) => {
                    if (
                      event?.activePayload &&
                      event.activePayload.length > 0
                    ) {
                      handleBarClick(event.activePayload[0].payload);
                    }
                  }}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis
                    type="number"
                    tickFormatter={(value) => value.toLocaleString("en-US")}
                    domain={[0, (dataMax: number) => roundToNearest(dataMax)]}
                  />
                  <YAxis
                    style={{ cursor: "default" }}
                    dataKey="SegmentName"
                    type="category"
                    width={150}
                    tick={{ textAnchor: "end" }}
                  />

                  <RechartsTooltip
                    content={(props) => <CustomTooltip {...props} />}
                  />

                  <Legend
                    content={() => (
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "14px",
                          fontWeight: "bold",
                        }}>
                        Total Member
                      </div>
                    )}
                  />

                  <Bar dataKey="Count" barSize={12}>
                    {dataSegmentBarChart.map((entry, index) => {
                      const getCellColor = (data: any, index: number) => {
                        return "#1565C0";
                      };
                      return (
                        <Cell
                          key={`cell-${index}`}
                          fill={getCellColor(entry, index)}
                        />
                      );
                    })}
                    <LabelList
                      dataKey="Count"
                      position="right"
                      style={{ fill: "#000", fontSize: 12 }}
                      formatter={(value: any) => value.toLocaleString("en-US")}
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          </Card>
        </Col>
      </Row>
      <Row style={{ marginTop: 20 }}>
        <Col xs={24} sm={24} lg={24}>
          <Card
            className="card-top-performers"
            title={
              <Row
                justify="space-between"
                align="middle"
                wrap
                style={{ width: "100%" }}>
                <Col
                  xs={24}
                  md={12}
                  xl={12}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                  }}>
                  <span
                    style={{
                      fontWeight: 600,
                      fontSize: 16,
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                    }}>
                    Member List Based on Filter
                  </span>
                  <Alert
                    style={{ width: isMobile ? "max-content" : 135 }}
                    className="alert-show-count"
                    description={
                      <div>
                        <span style={{ color: "#1565C0" }}>
                          {countMemberFilter.toLocaleString("en-US")}{" "}
                          Members{" "}
                        </span>
                      </div>
                    }
                    type="info"
                  />
                </Col>
                <Col
                  xs={24}
                  md={12}
                  xl={12}
                  style={{ textAlign: "right", marginTop: isMobile ? 10 : 0 }}>
                  {isMobile && (
                    <Button
                      type="primary"
                      block
                      icon={<DownloadOutlined />}
                      onClick={() => handleDownloadNow()}>
                      Download
                    </Button>
                  )}

                  {!isMobile && (
                    <Button
                      type="primary"
                      block
                      icon={<DownloadOutlined />}
                      style={{
                        width: isMobile ? 150 : 210,
                      }}
                      onClick={() => handleDownloadNow()}>
                      Download
                    </Button>
                  )}
                </Col>
              </Row>
            }>
            {isMobile && (
              <Row gutter={16} style={{ marginBottom: 24 }}>
                <Col span={24}>
                  <Button
                    color="default"
                    variant="outlined"
                    icon={<FilterOutlined />}
                    style={{ width: "100%" }}
                    onClick={() => setIsModalFilterVisible(true)}>
                    Filter
                  </Button>
                </Col>
              </Row>
            )}
            {!isMobile && (
              <Form layout="vertical">
                <Row gutter={16}>
                  {/* Filter Mode */}
                  <Col
                    xs={24}
                    lg={filterMode === "segment" ? 6 : 6}
                    md={filterMode === "segment" ? 6 : 6}
                    xl={filterMode === "segment" ? 6 : 6}>
                    <Form.Item label="Filter Mode">
                      <Select
                        style={{ width: "100%" }}
                        value={filterMode}
                        onChange={(val) => {
                          setFilterMode(val);
                        }}
                        options={[
                          {
                            value: "segment",
                            label: "Defined RFM Segment Selection",
                          },
                          {
                            value: "criteria",
                            label: "Manual RFM Criteria Selection",
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>

                  {/* Segment OR Criteria filters */}
                  {filterMode === "segment" ? (
                    <Col xs={24} lg={6} md={6} xl={6}>
                      <Form.Item label="Member Segment">
                        <Select
                          mode="multiple"
                          style={{ width: "100%" }}
                          placeholder="Select RFM Segment"
                          options={segmentOptions}
                          value={rfmFilter}
                          onChange={(values: string[]) => {
                            const allOption = "all";
                            const listSegmentFilter = segmentOptions
                              .filter((option) => option.value !== allOption)
                              .map((option) => option.value);

                            let updatedSelectedSegments: string[] = [];

                            if (
                              values.includes(allOption) &&
                              !rfmFilter?.includes(allOption)
                            ) {
                              updatedSelectedSegments = [
                                allOption,
                                ...listSegmentFilter,
                              ];
                            } else if (
                              !values.includes(allOption) &&
                              rfmFilter?.includes(allOption)
                            ) {
                              updatedSelectedSegments = [];
                            } else {
                              const allSelected = listSegmentFilter.every((s) =>
                                values.includes(s),
                              );

                              if (allSelected && !values.includes(allOption)) {
                                updatedSelectedSegments = [
                                  allOption,
                                  ...listSegmentFilter,
                                ];
                              } else {
                                updatedSelectedSegments = values.filter(
                                  (v) => v !== allOption,
                                );
                              }
                            }

                            setRfmFilter(updatedSelectedSegments);
                          }}
                          maxTagCount={0}
                          maxTagPlaceholder={() => {
                            const allOption = segmentOptions.find(
                              (option) => option.value === "all",
                            );
                            const allLabel = allOption
                              ? allOption.label
                              : "All Member Segment";

                            if (!rfmFilter || rfmFilter.includes("all")) {
                              return allLabel;
                            }

                            if (rfmFilter.length === 1) {
                              const selectedOption = segmentOptions.find(
                                (option) => option.value === rfmFilter[0],
                              );
                              return selectedOption?.label ?? rfmFilter[0];
                            }

                            return `${rfmFilter.length}/${
                              segmentOptions.length - 1
                            } selected`;
                          }}
                          removeIcon={null}
                        />
                      </Form.Item>
                    </Col>
                  ) : (
                    <>
                      <Col xs={24} lg={6} md={6} xl={6}>
                        <Form.Item label="Recency">
                          <Select
                            style={{ width: "100%" }}
                            mode="multiple"
                            placeholder="Select RFM Recency"
                            options={recencyOptions}
                            value={recencyFilter}
                            onChange={(values: string[]) => {
                              const allOption = "all";
                              const listRecencyFilter = recencyOptions
                                .filter((option) => option.value !== allOption)
                                .map((option) => option.value);

                              let updatedSelectedRecency: string[] = [];

                              if (
                                values.includes(allOption) &&
                                !recencyFilter?.includes(allOption)
                              ) {
                                updatedSelectedRecency = [
                                  allOption,
                                  ...listRecencyFilter,
                                ];
                              } else if (
                                !values.includes(allOption) &&
                                recencyFilter?.includes(allOption)
                              ) {
                                updatedSelectedRecency = [];
                              } else {
                                const allSelected = listRecencyFilter.every(
                                  (s) => values.includes(s),
                                );
                                if (
                                  allSelected &&
                                  !values.includes(allOption)
                                ) {
                                  updatedSelectedRecency = [
                                    allOption,
                                    ...listRecencyFilter,
                                  ];
                                } else {
                                  updatedSelectedRecency = values.filter(
                                    (v) => v !== allOption,
                                  );
                                }
                              }

                              setRecencyFilter(updatedSelectedRecency);
                            }}
                            maxTagCount={0}
                            maxTagPlaceholder={() => {
                              const allOption = recencyOptions.find(
                                (option) => option.value === "all",
                              );
                              const allLabel = allOption
                                ? allOption.label
                                : "All Recency Value";

                              if (
                                !recencyFilter ||
                                recencyFilter.includes("all")
                              ) {
                                return allLabel;
                              }

                              if (recencyFilter.length === 1) {
                                const selectedOption = recencyOptions.find(
                                  (option) => option.value === recencyFilter[0],
                                );
                                return (
                                  selectedOption?.label ?? recencyFilter[0]
                                );
                              }

                              return `${recencyFilter.length}/${
                                recencyOptions.length - 1
                              } selected`;
                            }}
                            removeIcon={null}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} lg={6} md={6} xl={6}>
                        <Form.Item label="Frequency">
                          <Select
                            mode="multiple"
                            style={{ width: "100%" }}
                            placeholder="Select RFM Frequency"
                            options={frequencyOptions}
                            value={frequencyFilter}
                            onChange={(values: string[]) => {
                              const allOption = "all";

                              const listFrequencyFilter = frequencyOptions
                                .filter((option) => option.value !== allOption)
                                .map((option) => option.value);

                              let updatedSelectedFrequency: string[] = [];

                              if (
                                values.includes(allOption) &&
                                !frequencyFilter?.includes(allOption)
                              ) {
                                updatedSelectedFrequency = [
                                  allOption,
                                  ...listFrequencyFilter,
                                ];
                              } else if (
                                !values.includes(allOption) &&
                                frequencyFilter?.includes(allOption)
                              ) {
                                updatedSelectedFrequency = [];
                              } else {
                                const allSelected = listFrequencyFilter.every(
                                  (s) => values.includes(s),
                                );

                                if (
                                  allSelected &&
                                  !values.includes(allOption)
                                ) {
                                  updatedSelectedFrequency = [
                                    allOption,
                                    ...listFrequencyFilter,
                                  ];
                                } else {
                                  updatedSelectedFrequency = values.filter(
                                    (v) => v !== allOption,
                                  );
                                }
                              }

                              setFrequencyFilter(updatedSelectedFrequency);
                            }}
                            maxTagCount={0}
                            maxTagPlaceholder={() => {
                              const allOption = frequencyOptions.find(
                                (option) => option.value === "all",
                              );
                              const allLabel = allOption
                                ? allOption.label
                                : "All Frequency Value";

                              if (
                                !frequencyFilter ||
                                frequencyFilter.includes("all")
                              ) {
                                return allLabel;
                              }

                              if (frequencyFilter.length === 1) {
                                const selectedOption = frequencyOptions.find(
                                  (option) =>
                                    option.value === frequencyFilter[0],
                                );
                                return (
                                  selectedOption?.label ?? frequencyFilter[0]
                                );
                              }

                              return `${frequencyFilter.length}/${
                                frequencyOptions.length - 1
                              } selected`;
                            }}
                            removeIcon={null}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} lg={6} md={6} xl={6}>
                        <Form.Item label="Monetary">
                          <Select
                            mode="multiple"
                            style={{ width: "100%" }}
                            placeholder="Select RFM Monetary"
                            options={monetaryOptions}
                            value={monetaryFilter}
                            maxTagCount={0}
                            onChange={(values: string[]) => {
                              const allOption = "all";

                              const listMonetaryFilter = monetaryOptions
                                .filter((option) => option.value !== allOption)
                                .map((option) => option.value);

                              let updatedSelectedMonetary: string[] = [];

                              if (
                                values.includes(allOption) &&
                                !monetaryFilter?.includes(allOption)
                              ) {
                                updatedSelectedMonetary = [
                                  allOption,
                                  ...listMonetaryFilter,
                                ];
                              } else if (
                                !values.includes(allOption) &&
                                monetaryFilter?.includes(allOption)
                              ) {
                                updatedSelectedMonetary = [];
                              } else {
                                const allSelected = listMonetaryFilter.every(
                                  (s) => values.includes(s),
                                );

                                if (
                                  allSelected &&
                                  !values.includes(allOption)
                                ) {
                                  updatedSelectedMonetary = [
                                    allOption,
                                    ...listMonetaryFilter,
                                  ];
                                } else {
                                  updatedSelectedMonetary = values.filter(
                                    (v) => v !== allOption,
                                  );
                                }
                              }

                              setMonetaryFilter(updatedSelectedMonetary);
                            }}
                            maxTagPlaceholder={() => {
                              const allOption = monetaryOptions.find(
                                (option) => option.value === "all",
                              );
                              const allLabel = allOption
                                ? allOption.label
                                : "All Monetary Value";

                              if (
                                !monetaryFilter ||
                                monetaryFilter.includes("all")
                              ) {
                                return allLabel;
                              }

                              if (monetaryFilter.length === 1) {
                                const selectedOption = monetaryOptions.find(
                                  (option) =>
                                    option.value === monetaryFilter[0],
                                );
                                return (
                                  selectedOption?.label ?? monetaryFilter[0]
                                );
                              }

                              return `${monetaryFilter.length}/${
                                monetaryOptions.length - 1
                              } selected`;
                            }}
                            removeIcon={null}
                          />
                        </Form.Item>
                      </Col>
                    </>
                  )}
                  <Col
                    xs={24}
                    lg={filterMode === "segment" ? 6 : 6}
                    md={filterMode === "segment" ? 6 : 6}
                    xl={filterMode === "segment" ? 6 : 6}>
                    <Form.Item label="Goals Met Selector">
                      <Select
                        style={{ width: "100%" }}
                        value={filterCampaign}
                        onChange={(val) => {
                          setFilterCampaign(val);
                        }}
                        placeholder={"Select Campaign"}
                        allowClear>
                        {listCampaign?.map((item) => (
                          <Select.Option key={item.Id} value={item.Id}>
                            {item.Name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  {/* Apply button */}
                  {filterMode !== "segment" && (
                    <>
                      <Col xs={24} lg={6} md={6} xl={6}></Col>
                      <Col xs={24} lg={6} md={6} xl={6}></Col>
                    </>
                  )}
                  <Col
                    xs={24}
                    lg={filterMode === "segment" ? 6 : 6}
                    md={filterMode === "segment" ? 6 : 6}
                    xl={filterMode === "segment" ? 6 : 6}>
                    <Form.Item label=" ">
                      <Button
                        type="primary"
                        className="w-100"
                        onClick={applyAllFilter}>
                        Apply Filter
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            )}
            {dataTopPerformers.length === 10 && (
              <Alert
                style={{ marginBottom: 24 }}
                description={
                  <span style={{ color: "#1565C0" }}>
                    This preview shows the first 10 rows as a sample. Download
                    the file to see the full data.
                  </span>
                }
                type="info"
                showIcon
              />
            )}

            <Table
              className="table-top-performers"
              columns={visibleColumns}
              dataSource={dataTopPerformers}
              pagination={false}
              scroll={{ x: "max-content" }}
              tableLayout={isTablet ? "auto" : "fixed"}
              style={{ width: "100%", fontSize: "11px" }}
            />
          </Card>
        </Col>
      </Row>
      <Modal
        title={
          <span style={{ fontSize: "16px", fontWeight: "bold" }}>
            Edit Criteria RFM Table
          </span>
        }
        className="modal-edit-criteria"
        open={isEditModalVisible}
        onCancel={() => resetEditForm(false)}
        footer={null}
        width={800}
        style={{
          top: 0,
        }}
        maskClosable={false}>
        <Divider style={{ margin: "12px 0px" }} />
        <Row className="rfm-tabs">
          <Col xs={24} lg={12} md={12} xl={12}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                gap: 8,
              }}>
              <span style={{ whiteSpace: "nowrap" }}>Load Profile</span>
              <Select
                key={selectKey}
                style={{ width: "70%" }}
                placeholder="Select RFM Profile"
                onChange={(value) => handleLoadProfile(value)}
                notFoundContent="No Profile yet"
                value={selectedRFMProfile ? selectedRFMProfile.Id : undefined}>
                {/* {defaultProfile.map((profile) => (
                  <Option key={profile.Id} value={profile.Id}>
                    {profile.Name}
                  </Option>
                ))} */}
                {rfmProfile.map((profile) => (
                  <Option key={profile.Id} value={profile.Id}>
                    {profile.Name}
                  </Option>
                ))}
              </Select>
            </div>
          </Col>
          <Col
            xs={24}
            lg={12}
            md={12}
            xl={12}
            style={{
              textAlign: isMobile ? "center" : "right",
              marginTop: isMobile ? 10 : "unset",
            }}>
            <Space>
              <Button
                size="middle"
                onClick={() => {
                  setActiveTab("Recency");
                  setIsTyping(false);
                }}
                type={activeTab === "Recency" ? "primary" : "default"}>
                Recency
              </Button>
              <Button
                size="middle"
                onClick={() => {
                  setActiveTab("Frequency");
                  setIsTyping(false);
                }}
                type={activeTab === "Frequency" ? "primary" : "default"}>
                Frequency
              </Button>
              <Button
                size="middle"
                onClick={() => {
                  setActiveTab("Monetary");
                  setIsTyping(false);
                }}
                type={activeTab === "Monetary" ? "primary" : "default"}>
                Monetary
              </Button>
            </Space>
          </Col>
        </Row>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={initialValues}
          onValuesChange={onValuesChange}>
          <Card
            title={
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                {activeTab}
              </span>
            }
            className="card-edit-criteria-table"
            variant="borderless"
            type="inner"
            style={{ width: "100%", marginTop: isMobile ? 5 : 25 }}>
            {["Recency", "Frequency", "Monetary"].map((section) => {
              const isFrequency = section === "Frequency";
              const dataSource = isFrequency
                ? (updatedBrandRFMSetting ?? [])
                : (brandRFMSetting ?? []);

              return (
                <div
                  key={section}
                  className="rfm-section"
                  style={{
                    display: activeTab === section ? "block" : "none",
                  }}>
                  {isFrequency && (
                    <Row
                      gutter={[16, 8]}
                      className="rfm-row"
                      align="middle"
                      justify="space-between">
                      <Col xs={24} md={6} xl={6}>
                        <span style={{ fontSize: 14 }}>Selected Period</span>
                      </Col>
                      <Col xs={24} md={7} xl={7}>
                        <Select
                          size="middle"
                          style={{
                            width: "100%",
                            display: "block",
                          }}
                          value={cutOffDateInEdit}
                          onChange={handleChangeCutOffDateInEdit}>
                          {optionsCutOffDateOnEdit.map((option) => (
                            <Option key={option.value} value={option.value}>
                              {option.label}
                            </Option>
                          ))}
                        </Select>
                      </Col>
                      <Col span={1}></Col>
                      <Col span={6}></Col>
                    </Row>
                  )}
                  <div
                    style={{
                      flex: 1,
                      height:
                        isMobile && section === "Monetary" ? "60vh" : "auto",
                      overflowY: "auto",
                      overflowX: "hidden",
                      paddingRight: isMobile ? 8 : 0,
                      marginBottom: 10,
                    }}>
                    {activeTab === "Monetary" && (
                      <Card
                        style={{
                          background: "rgba(0,0,0,0.02)",
                          borderRadius: 8,
                          border: "1px solid #e5e7eb",
                          marginBottom: 10,
                          padding: "2px",
                        }}
                        bodyStyle={{
                          padding: "5px",
                        }}>
                        <Row
                          align="middle"
                          justify="space-between"
                          gutter={[32, 0]}>
                          {/* Left Label */}
                          <Col xs={24} md={6} xl={6}>
                            <Text
                              strong
                              style={{ fontSize: 14, color: "#1f2937" }}>
                              Calculation Mode
                            </Text>
                          </Col>

                          {/* Right Options */}
                          <Col xs={24} md={18} xl={18}>
                            <Radio.Group
                              value={
                                selectedRFMProfile?.IsAuto ? "auto" : "fixed"
                              }
                              size="large"
                              onChange={(e) => {
                                const mode = e.target.value;

                                if (mode === "auto") {
                                  let newProfile = {
                                    ...selectedRFMProfile,
                                    IsAuto: true,
                                  };

                                  const matchedProfile = defaultProfile.find(
                                    (p) => p.Name === selectedRFMProfile?.Name,
                                  );

                                  const fallback =
                                    selectedRFMProfile?.Name ===
                                    "Full Service Default Profiles"
                                      ? defaultProfile.find(
                                          (p) =>
                                            p.Name ===
                                            "Full Service Default Profiles",
                                        )
                                      : defaultProfile.find(
                                          (p) =>
                                            p.Name ===
                                            "Quick Service Default Profiles",
                                        );

                                  const activeProfile =
                                    matchedProfile || fallback;

                                  if (activeProfile?.BrandRFMProfileSetting) {
                                    newProfile.BrandRFMProfileSetting =
                                      activeProfile.BrandRFMProfileSetting;

                                    const {
                                      mappedData,
                                      newRFMSettings,
                                      transformedData,
                                    } = prepareRFMSettings(
                                      activeProfile,
                                      brandId ?? "",
                                      selectedPeriod,
                                      applyFrequencyDataUpdate,
                                    );

                                    setBrandRFMSetting(mappedData);
                                    setRfmSettings(transformedData);
                                    setUpdatedBrandRFMSetting(newRFMSettings);
                                  }

                                  setSelectedRFMProfile(newProfile);
                                } else {
                                  const matchedProfile = rfmProfile?.find(
                                    (p) => p.Id === selectedRFMProfile?.Id,
                                  );

                                  const updatedProfile = {
                                    ...selectedRFMProfile,
                                    IsAuto: false,
                                    BrandRFMProfileSetting:
                                      matchedProfile?.BrandRFMProfileSetting ??
                                      selectedRFMProfile.BrandRFMProfileSetting,
                                  };

                                  setSelectedRFMProfile(updatedProfile);

                                  if (updatedProfile?.BrandRFMProfileSetting) {
                                    const {
                                      mappedData,
                                      newRFMSettings,
                                      transformedData,
                                    } = prepareRFMSettings(
                                      updatedProfile,
                                      brandId ?? "",
                                      selectedPeriod,
                                      applyFrequencyDataUpdate,
                                    );

                                    setBrandRFMSetting(mappedData);
                                    setRfmSettings(transformedData);
                                    setUpdatedBrandRFMSetting(newRFMSettings);
                                  }
                                }
                              }}>
                              <Row gutter={[32, 0]} align="top">
                                {/* Auto */}
                                <Col>
                                  <Radio value="auto" disabled={isDisabled}>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        opacity: isDisabled ? 0.5 : 1,
                                      }}>
                                      <Text strong>Auto (Dynamic)</Text>
                                      <Text
                                        type="secondary"
                                        style={{ fontSize: 12 }}>
                                        Values may update daily
                                      </Text>
                                    </div>
                                  </Radio>
                                </Col>

                                {/* Fixed */}
                                <Col>
                                  <Radio value="fixed">
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}>
                                      <Text strong>Fixed (Manual Input)</Text>
                                      <Text
                                        type="secondary"
                                        style={{ fontSize: 12 }}>
                                        Set your own static values manually
                                      </Text>
                                    </div>
                                  </Radio>
                                </Col>
                              </Row>
                            </Radio.Group>
                          </Col>
                        </Row>
                      </Card>
                    )}
                    {dataSource
                      .filter(
                        (item: any) =>
                          item.RFMType ===
                          RFMType[section as keyof typeof RFMType],
                      )
                      .map((tier: any, index: any) => (
                        <Row
                          key={index}
                          gutter={[16, 8]}
                          align="middle"
                          justify="space-between"
                          className="rfm-row">
                          <Col xs={24} md={6} xl={6}>
                            <span style={{ fontSize: 14 }}>
                              {RFMTierDescriptions[tier.RFMTier as RFMTier] ??
                                "Unknown"}{" "}
                              Value
                            </span>
                          </Col>
                          <Col xs={10} md={6} xl={6}>
                            <Form.Item
                              label=""
                              validateTrigger={["onBlur", "onChange"]}
                              name={`${tier.RFMType}-${tier.RFMTier}-start`}
                              style={{ marginBottom: 0 }}
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    if (index === 0) {
                                      if (
                                        section === "Frequency" &&
                                        (value === "" ||
                                          value === undefined ||
                                          value === 0)
                                      ) {
                                        return Promise.resolve();
                                      }
                                      if (
                                        section === "Frequency" &&
                                        value < 0 &&
                                        (value !== "" || value !== undefined)
                                      ) {
                                        return Promise.reject(
                                          new Error(
                                            "Value must be greater than 0",
                                          ),
                                        );
                                      }
                                      if (
                                        section === "Monetary" &&
                                        (value === undefined || value < 0)
                                      ) {
                                        return Promise.reject(
                                          new Error("Value cannot be negative"),
                                        );
                                      }
                                    }
                                    return Promise.resolve();
                                  },
                                }),
                              ]}>
                              {
                                <InputNumber<string>
                                  size="middle"
                                  step={
                                    section === "Frequency"
                                      ? 0.1
                                      : section === "Recency"
                                        ? 1
                                        : 0.01
                                  }
                                  decimalSeparator="."
                                  onFocus={() => {
                                    setIsTyping(false);
                                  }}
                                  onChange={() => {
                                    setIsTyping(true);
                                    setIsValueChanges(true);
                                  }}
                                  stringMode
                                  formatter={(value) => {
                                    if (!value) return "";

                                    if (section === "Frequency") {
                                      const num: any = parseFloat(
                                        value.toString().replace(/,/g, "."),
                                      );
                                      if (
                                        value === "0" &&
                                        !isTyping &&
                                        tier.RFMTier === RFMTier.VeryLow
                                      ) {
                                        return "";
                                      }

                                      return Number.isInteger(num)
                                        ? num.toString()
                                        : num.toFixed(1);
                                    }
                                    if (section === "Monetary") {
                                      const num = parseFloat(
                                        value.toString().replace(/,/g, "."),
                                      );
                                      if (
                                        value === "0" &&
                                        !isTyping &&
                                        tier.RFMTier === RFMTier.VeryLow
                                      ) {
                                        return "";
                                      }
                                      return Number.isInteger(num)
                                        ? num.toString()
                                        : num.toFixed(2);
                                    }
                                    return value.toString().replace(/,/g, ".");
                                  }}
                                  parser={(value) => {
                                    if (!value) return "";
                                    return value.replace(/,/g, ".");
                                  }}
                                  readOnly={
                                    !(
                                      index === 0 &&
                                      (section === "Monetary" ||
                                        section === "Frequency")
                                    )
                                  }
                                  disabled={
                                    !(
                                      index === 0 &&
                                      (section === "Monetary" ||
                                        section === "Frequency")
                                    ) ||
                                    (index === 0 &&
                                      section === "Monetary" &&
                                      selectedRFMProfile?.IsAuto === true)
                                  }
                                  addonAfter={
                                    <>
                                      {tier.RFMStartValue === 0 ? (
                                        <Tooltip
                                          title={
                                            tooltipTexts[
                                              `${tier.RFMType}-${tier.RFMTier}-end`
                                            ] || ""
                                          }>
                                          <span style={{ marginRight: 5 }}>
                                            {section === "Monetary"
                                              ? "$"
                                              : section === "Frequency"
                                                ? "Orders"
                                                : "Days"}
                                          </span>
                                        </Tooltip>
                                      ) : (
                                        <span style={{ marginRight: 5 }}>
                                          {section === "Monetary"
                                            ? "$"
                                            : section === "Frequency"
                                              ? "Orders"
                                              : "Days"}
                                        </span>
                                      )}
                                    </>
                                  }
                                />
                              }
                            </Form.Item>
                          </Col>
                          <Col
                            xs={3}
                            md={2}
                            xl={2}
                            style={{ textAlign: "center", fontSize: 16 }}>
                            To
                          </Col>
                          <Col xs={10} md={6} xl={6}>
                            <Form.Item
                              name={`${tier.RFMType}-${tier.RFMTier}-end`}
                              style={{ marginBottom: 0 }}
                              dependencies={[
                                `${tier.RFMType}-${tier.RFMTier}-start`,
                                `${tier.RFMType}-${
                                  (tier.RFMTier ?? 0) + 1
                                }-start`,
                              ]}
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    const currentTier = tier.RFMTier ?? 0;
                                    const startValue = getFieldValue(
                                      `${tier.RFMType}-${currentTier}-start`,
                                    );
                                    if (
                                      (value === null ||
                                        value === undefined ||
                                        startValue === undefined) &&
                                      ((tier.RFMTier === RFMTier.VeryHigh &&
                                        tier.RFMType === RFMType.Frequency) ||
                                        (tier.RFMTier === RFMTier.VeryLow &&
                                          tier.RFMType === RFMType.Recency) ||
                                        (tier.RFMTier === RFMTier.VeryHigh &&
                                          tier.RFMType === RFMType.Monetary))
                                    ) {
                                      return Promise.resolve();
                                    }

                                    if (tier.RFMType === RFMType.Frequency) {
                                      if (
                                        value <= startValue &&
                                        tier.RFMTier !== RFMTier.VeryLow &&
                                        tier.RFMTier !== RFMTier.VeryHigh
                                      ) {
                                        return Promise.reject(
                                          new Error(
                                            `End value must be greater than ${startValue}`,
                                          ),
                                        );
                                      }
                                      if (
                                        value < startValue &&
                                        (value === null || value === "0")
                                      ) {
                                        return Promise.reject(
                                          new Error(
                                            `End value must be greater than or equal to ${startValue}`,
                                          ),
                                        );
                                      }
                                    } else {
                                      if (
                                        value <= startValue &&
                                        tier.RFMType === RFMType.Monetary &&
                                        tier.RFMTier === RFMTier.VeryHigh &&
                                        (value === "" ||
                                          value === null ||
                                          value === "0") &&
                                        !isTyping
                                      ) {
                                        return Promise.resolve();
                                      }
                                      if (
                                        (value === "" ||
                                          value === null ||
                                          value === "0" ||
                                          value === 0) &&
                                        (tier.RFMTier === RFMTier.VeryHigh ||
                                          tier.RFMTier === RFMTier.VeryLow)
                                      ) {
                                        return Promise.resolve();
                                      }
                                      if (value <= startValue) {
                                        return Promise.reject(
                                          new Error(
                                            `End value must be greater than ${startValue}`,
                                          ),
                                        );
                                      }
                                      if (value === null || value === "0") {
                                        return Promise.reject(
                                          new Error(
                                            `End value must be greater than 0`,
                                          ),
                                        );
                                      }
                                    }

                                    return Promise.resolve();
                                  },
                                }),
                              ]}>
                              <InputNumber<string>
                                value={tier.RFMEndValue}
                                size="middle"
                                step={
                                  section === "Frequency"
                                    ? 0.1
                                    : section === "Recency"
                                      ? 1
                                      : 0.01
                                }
                                onFocus={() => {
                                  setIsTypingEndValue(false);
                                }}
                                decimalSeparator="."
                                stringMode
                                formatter={(value) => {
                                  if (!value) return "";
                                  const num = parseFloat(
                                    value.toString().replace(/,/g, "."),
                                  );

                                  if (section === "Recency") {
                                    if (
                                      (value === "0" ||
                                        value === null ||
                                        value === undefined) &&
                                      !isTypingEndValue &&
                                      tier.RFMTier === RFMTier.VeryLow
                                    )
                                      return "";
                                    return Math.floor(num).toString();
                                  }
                                  if (section === "Frequency") {
                                    const num = parseFloat(
                                      value.toString().replace(/,/g, "."),
                                    );
                                    if (
                                      (value === "0" || value === null) &&
                                      !isTypingEndValue &&
                                      tier.RFMTier === RFMTier.VeryHigh
                                    )
                                      return "";

                                    const rounded = Math.round(num * 10) / 10;

                                    return Number.isInteger(rounded)
                                      ? rounded.toString()
                                      : rounded.toFixed(1);
                                  }
                                  if (section === "Monetary") {
                                    const num = parseFloat(
                                      value.toString().replace(/,/g, "."),
                                    );
                                    if (
                                      (value === "0" ||
                                        value === null ||
                                        Number(value) === 0) &&
                                      !isTypingEndValue &&
                                      tier.RFMTier === RFMTier.VeryHigh
                                    ) {
                                      return "";
                                    }

                                    return Number.isInteger(num)
                                      ? num.toString()
                                      : num.toFixed(2);
                                  }
                                  return value.toString().replace(/,/g, ".");
                                }}
                                parser={(value) =>
                                  value ? value.replace(/,/g, ".") : ""
                                }
                                addonAfter={
                                  <>
                                    {tier.RFMEndValue === 0 ? (
                                      <Tooltip
                                        title={
                                          tooltipTexts[
                                            `${tier.RFMType}-${tier.RFMTier}-start`
                                          ] || ""
                                        }>
                                        <span style={{ marginRight: 5 }}>
                                          {section === "Monetary"
                                            ? "$"
                                            : section === "Frequency"
                                              ? "Orders"
                                              : "Days"}
                                        </span>
                                      </Tooltip>
                                    ) : (
                                      <span style={{ marginRight: 5 }}>
                                        {section === "Monetary"
                                          ? "$"
                                          : section === "Frequency"
                                            ? "Orders"
                                            : "Days"}
                                      </span>
                                    )}
                                  </>
                                }
                                onChange={(value) => {
                                  setIsTypingEndValue(true);
                                  setIsValueChanges(true);

                                  if (!value) return;

                                  const newEndValue = Number(value);
                                  const currentTier = tier.RFMTier ?? 0;
                                  const nextTierKey =
                                    section === "Recency"
                                      ? `${tier.RFMType}-${
                                          currentTier + 1
                                        }-start`
                                      : `${tier.RFMType}-${
                                          currentTier - 1
                                        }-start`;

                                  if (!isNaN(newEndValue) && newEndValue > 0) {
                                    const currentTierGroup = dataSource.filter(
                                      (t: any) => t.RFMType === tier.RFMType,
                                    );
                                    const allHaveDecimals =
                                      tier.RFMType === RFMType.Frequency &&
                                      tier.RFMType !== RFMType.Recency &&
                                      currentTierGroup.some((t: any) => {
                                        const startVal = Number(
                                          t.RFMStartValue,
                                        );
                                        const endVal = Number(t.RFMEndValue);

                                        return (
                                          (!Number.isNaN(startVal) &&
                                            !Number.isInteger(startVal)) ||
                                          (!Number.isNaN(endVal) &&
                                            !Number.isInteger(endVal))
                                        );
                                      });

                                    form.setFieldsValue({
                                      [nextTierKey]:
                                        newEndValue +
                                        (section === "Monetary"
                                          ? 0.01
                                          : allHaveDecimals
                                            ? 0.1
                                            : 1),
                                    });
                                  }

                                  form.validateFields([
                                    section !== "Recency"
                                      ? `${tier.RFMType}-${currentTier - 1}-end`
                                      : `${tier.RFMType}-${
                                          currentTier + 1
                                        }-end`,
                                  ]);
                                }}
                                disabled={
                                  section === "Monetary"
                                    ? selectedRFMProfile?.IsAuto
                                    : false
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      ))}
                    {section === "Monetary" && (
                      <Row style={{ marginTop: isMobile ? 10 : 0 }}>
                        <Col span={24}>
                          <Alert
                            message={
                              <strong>Default Calculation Rules:</strong>
                            }
                            description={
                              <>
                                <ul style={{ paddingLeft: 20, margin: 0 }}>
                                  <li>
                                    Average Order Value (AOV) = ${" "}
                                    {(
                                      (defaultSetting?.find(
                                        (item: any) => item.RFMType === 3,
                                      )?.RFMEndValue ?? 0) * 4
                                    ).toLocaleString("en-US", {
                                      maximumFractionDigits: 2,
                                    })}
                                  </li>{" "}
                                  <li>
                                    Default Monetary Value = Default Frequency
                                    Value * AOV
                                  </li>
                                </ul>
                              </>
                            }
                            type="info"
                            showIcon
                          />
                        </Col>
                      </Row>
                    )}
                  </div>
                </div>
              );
            })}
            <Divider style={{ margin: "12px 0px" }} />
            <Row justify="space-between">
              <Col xs={24} md={12} lg={12}></Col>
              <Col xs={24} md={12} lg={12} style={{ textAlign: "right" }}>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Button
                      key="back"
                      onClick={() => resetEditForm(false)}
                      style={{
                        height: 40,
                        width: isMobile ? "100%" : 150,
                        fontSize: 14,
                      }}>
                      Cancel
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      key="submit"
                      type="primary"
                      htmlType="submit"
                      loading={loadingButton}
                      style={{
                        backgroundColor: "#1565C0",
                        height: 40,
                        width: isMobile ? "100%" : 150,
                        fontSize: 14,
                      }}>
                      Save
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
        </Form>
      </Modal>
      <CustomModal
        type="success"
        title={titleModalSuccess}
        message={messageModalSuccess}
        isVisible={isModalSuccessVisible}
        onClose={closeModalSuccess}
        autoClose
        duration={3000}
      />
      <CustomModal
        type="error"
        title="Updated Criteria RFM"
        message="Something went wrong. Please try again."
        isVisible={isErrorModalVisible}
        onClose={closeErrorModal}
        autoClose
        duration={3000}
      />
      <Modal
        title=""
        open={isConfirmationModalProfileVisible}
        width={550}
        height={300}
        onCancel={() => setIsConfirmationModalProfileVisible(false)}
        centered
        footer={
          <>
            <Divider />
            <Row gutter={16}>
              <Col span={12}>
                <Button
                  size="large"
                  variant="outlined"
                  color="primary"
                  className="w-100"
                  style={{ height: 52, fontWeight: "bold" }}
                  disabled={rfmProfile.length >= 10}
                  onClick={() => {
                    setConfirmationProfile(true);
                    setIsConfirmationModalProfileVisible(false);
                    setIsModalCreateProfileVisible(true);
                  }}>
                  Save as New
                </Button>
              </Col>
              <Col span={12}>
                <Button
                  size="large"
                  key="edit"
                  type="primary"
                  style={{
                    backgroundColor: "#1565C0",
                    color: "white",
                    height: 52,
                  }}
                  className="w-100"
                  onClick={() => {
                    setConfirmationProfile(true);

                    setIsConfirmationModalProfileVisible(false);
                    handleUpdateProfile();
                  }}>
                  Overwrite
                </Button>
              </Col>
            </Row>
          </>
        }>
        <Row justify={"center"} style={{ marginTop: 25 }}>
          <WarningFilled style={{ color: "#EEB711", fontSize: 100 }} />{" "}
        </Row>{" "}
        <Row justify={"center"} style={{ fontSize: 16, fontWeight: "bold" }}>
          You’ve made changes to the profile
        </Row>
        <Row justify={"center"}>
          Would you like to overwrite the existing profile or save it as a new
          one?{" "}
        </Row>
        <Row justify={"center"}>
          {rfmProfile.length >= 10 && (
            <Alert
              type="error"
              message="Maximum of 10 profiles allowed. Please delete one before adding."
              banner
            />
          )}
        </Row>
      </Modal>
      <Modal
        title=""
        open={isConfirmationModalVisible}
        width={550}
        height={300}
        onCancel={() => setIsConfirmationModalVisible(false)}
        maskClosable={false}
        closable={false}
        centered
        footer={
          <>
            <Divider />
            <Row gutter={16}>
              <Col span={12}>
                <Button
                  size="large"
                  key="cancel"
                  className="w-100"
                  style={{ height: 52 }}
                  onClick={() => {
                    setIsConfirmationModalVisible(false);
                  }}>
                  Cancel
                </Button>
              </Col>
              <Col span={12}>
                <Button
                  size="large"
                  key="edit"
                  type="primary"
                  style={{
                    backgroundColor: "#1565C0",
                    color: "white",
                    height: 52,
                  }}
                  onClick={() => resetBrandRFMSettings()}
                  className="w-100">
                  Confirm
                </Button>
              </Col>
            </Row>
          </>
        }>
        <Row justify={"center"} style={{ marginTop: 25 }}>
          <WarningFilled style={{ color: "#EEB711", fontSize: 100 }} />{" "}
        </Row>{" "}
        <Row justify={"center"} style={{ fontSize: 16, fontWeight: "bold" }}>
          Update to Default Settings
        </Row>
        <Row justify={"center"}>
          Are you sure you want to update to default?{" "}
        </Row>
      </Modal>
      <CustomModal
        type="success"
        title="Update to Default Settings"
        message="Update to default settings has been saved successfully"
        isVisible={isUpdateDefaultModalSuccessVisible}
        onClose={() => setIsUpdateDefaultModalSuccessVisible(false)}
        autoClose
        duration={3000}
      />
      <Modal
        title="RFM Profile Settings"
        open={isModalCreateProfileVisible}
        onCancel={() => setIsModalCreateProfileVisible(false)}
        footer={null}>
        <Form
          requiredMark={false}
          form={form1}
          className="form-create-profile"
          onFinish={handleCreateProfile}
          {...layout}>
          <Form.Item
            name="name"
            label="Name Profile"
            rules={[
              { required: true, message: "Please input the name profile!" },
            ]}>
            <Input placeholder="Input name profile" />
          </Form.Item>
          <Form.Item
            name="description"
            label="Description Profile"
            rules={[
              { required: true, message: "Please input the description!" },
            ]}>
            <Input.TextArea placeholder="Input description profile" />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8 }}>
            <Button
              size="large"
              onClick={() => setIsModalCreateProfileVisible(false)}>
              Cancel
            </Button>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              loading={loadingButton}
              style={{ marginLeft: 8 }}>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="Filter"
        className="filter-modal"
        open={isModalFilterVisible}
        style={{ bottom: 0 }}
        footer={null}
        transitionName=""
        maskTransitionName=""
        maskClosable={false}
        onCancel={() => setIsModalFilterVisible(false)}
        modalRender={(modal) => (
          <div style={{ position: "fixed", bottom: 0, width: "100%" }}>
            {modal}
          </div>
        )}>
        <Form layout="vertical">
          <Row gutter={16}>
            {/* Filter Mode */}
            <Col
              xs={24}
              lg={filterMode === "segment" ? 9 : 5}
              md={filterMode === "segment" ? 9 : 5}
              xl={filterMode === "segment" ? 9 : 5}>
              <Form.Item label="Filter Mode" style={{ marginBottom: 5 }}>
                <Select
                  style={{ width: "100%" }}
                  value={filterMode}
                  onChange={(val) => {
                    setFilterMode(val);
                  }}
                  options={[
                    {
                      value: "segment",
                      label: "Defined RFM Segment Selection",
                    },
                    {
                      value: "criteria",
                      label: "Manual RFM Criteria Selection",
                    },
                  ]}
                />
              </Form.Item>
            </Col>

            {/* Segment OR Criteria filters */}
            {filterMode === "segment" ? (
              <Col xs={24} lg={9} md={9} xl={9}>
                <Form.Item label="Member Segment" style={{ marginBottom: 5 }}>
                  <Select
                    mode="multiple"
                    style={{ width: "100%" }}
                    placeholder="Select RFM Segment"
                    options={segmentOptions}
                    value={rfmFilter}
                    onChange={(values: string[]) => {
                      const allOption = "all";
                      const listSegmentFilter = segmentOptions
                        .filter((option) => option.value !== allOption)
                        .map((option) => option.value);

                      let updatedSelectedSegments: string[] = [];

                      if (
                        values.includes(allOption) &&
                        !rfmFilter?.includes(allOption)
                      ) {
                        updatedSelectedSegments = [
                          allOption,
                          ...listSegmentFilter,
                        ];
                      } else if (
                        !values.includes(allOption) &&
                        rfmFilter?.includes(allOption)
                      ) {
                        updatedSelectedSegments = [];
                      } else {
                        const allSelected = listSegmentFilter.every((s) =>
                          values.includes(s),
                        );

                        if (allSelected && !values.includes(allOption)) {
                          updatedSelectedSegments = [
                            allOption,
                            ...listSegmentFilter,
                          ];
                        } else {
                          updatedSelectedSegments = values.filter(
                            (v) => v !== allOption,
                          );
                        }
                      }

                      setRfmFilter(updatedSelectedSegments);
                    }}
                    maxTagCount={0}
                    maxTagPlaceholder={() => {
                      const allOption = segmentOptions.find(
                        (option) => option.value === "all",
                      );
                      const allLabel = allOption
                        ? allOption.label
                        : "All Member Segment";

                      if (!rfmFilter || rfmFilter.includes("all")) {
                        return allLabel;
                      }

                      if (rfmFilter.length === 1) {
                        const selectedOption = segmentOptions.find(
                          (option) => option.value === rfmFilter[0],
                        );
                        return selectedOption?.label ?? rfmFilter[0];
                      }

                      return `${rfmFilter.length}/${
                        segmentOptions.length - 1
                      } selected`;
                    }}
                    removeIcon={null}
                  />
                </Form.Item>
              </Col>
            ) : (
              <>
                <Col xs={24} lg={5} md={5} xl={5}>
                  <Form.Item label="Recency" style={{ marginBottom: 5 }}>
                    <Select
                      style={{ width: "100%" }}
                      mode="multiple"
                      placeholder="Select RFM Recency"
                      options={recencyOptions}
                      value={recencyFilter}
                      onChange={(values: string[]) => {
                        const allOption = "all";
                        const listRecencyFilter = recencyOptions
                          .filter((option) => option.value !== allOption)
                          .map((option) => option.value);

                        let updatedSelectedRecency: string[] = [];

                        if (
                          values.includes(allOption) &&
                          !recencyFilter?.includes(allOption)
                        ) {
                          updatedSelectedRecency = [
                            allOption,
                            ...listRecencyFilter,
                          ];
                        } else if (
                          !values.includes(allOption) &&
                          recencyFilter?.includes(allOption)
                        ) {
                          updatedSelectedRecency = [];
                        } else {
                          const allSelected = listRecencyFilter.every((s) =>
                            values.includes(s),
                          );
                          if (allSelected && !values.includes(allOption)) {
                            updatedSelectedRecency = [
                              allOption,
                              ...listRecencyFilter,
                            ];
                          } else {
                            updatedSelectedRecency = values.filter(
                              (v) => v !== allOption,
                            );
                          }
                        }

                        setRecencyFilter(updatedSelectedRecency);
                      }}
                      maxTagCount={0}
                      maxTagPlaceholder={() => {
                        const allOption = recencyOptions.find(
                          (option) => option.value === "all",
                        );
                        const allLabel = allOption
                          ? allOption.label
                          : "All Recency Value";

                        if (!recencyFilter || recencyFilter.includes("all")) {
                          return allLabel;
                        }

                        if (recencyFilter.length === 1) {
                          const selectedOption = recencyOptions.find(
                            (option) => option.value === recencyFilter[0],
                          );
                          return selectedOption?.label ?? recencyFilter[0];
                        }

                        return `${recencyFilter.length}/${
                          recencyOptions.length - 1
                        } selected`;
                      }}
                      showSearch={false}
                      filterOption={false}
                      removeIcon={null}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={5} md={5} xl={5}>
                  <Form.Item label="Frequency" style={{ marginBottom: 5 }}>
                    <Select
                      mode="multiple"
                      style={{ width: "100%" }}
                      placeholder="Select RFM Frequency"
                      options={frequencyOptions}
                      value={frequencyFilter}
                      onChange={(values: string[]) => {
                        const allOption = "all";

                        const listFrequencyFilter = frequencyOptions
                          .filter((option) => option.value !== allOption)
                          .map((option) => option.value);

                        let updatedSelectedFrequency: string[] = [];

                        if (
                          values.includes(allOption) &&
                          !frequencyFilter?.includes(allOption)
                        ) {
                          updatedSelectedFrequency = [
                            allOption,
                            ...listFrequencyFilter,
                          ];
                        } else if (
                          !values.includes(allOption) &&
                          frequencyFilter?.includes(allOption)
                        ) {
                          updatedSelectedFrequency = [];
                        } else {
                          const allSelected = listFrequencyFilter.every((s) =>
                            values.includes(s),
                          );

                          if (allSelected && !values.includes(allOption)) {
                            updatedSelectedFrequency = [
                              allOption,
                              ...listFrequencyFilter,
                            ];
                          } else {
                            updatedSelectedFrequency = values.filter(
                              (v) => v !== allOption,
                            );
                          }
                        }

                        setFrequencyFilter(updatedSelectedFrequency);
                      }}
                      showSearch={false}
                      filterOption={false}
                      maxTagCount={0}
                      maxTagPlaceholder={() => {
                        const allOption = frequencyOptions.find(
                          (option) => option.value === "all",
                        );
                        const allLabel = allOption
                          ? allOption.label
                          : "All Frequency Value";

                        if (
                          !frequencyFilter ||
                          frequencyFilter.includes("all")
                        ) {
                          return allLabel;
                        }

                        if (frequencyFilter.length === 1) {
                          const selectedOption = frequencyOptions.find(
                            (option) => option.value === frequencyFilter[0],
                          );
                          return selectedOption?.label ?? frequencyFilter[0];
                        }

                        return `${frequencyFilter.length}/${
                          frequencyOptions.length - 1
                        } selected`;
                      }}
                      removeIcon={null}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={5} md={5} xl={5}>
                  <Form.Item label="Monetary" style={{ marginBottom: 5 }}>
                    <Select
                      mode="multiple"
                      style={{ width: "100%" }}
                      placeholder="Select RFM Monetary"
                      options={monetaryOptions}
                      value={monetaryFilter}
                      maxTagCount={0}
                      onChange={(values: string[]) => {
                        const allOption = "all";

                        const listMonetaryFilter = monetaryOptions
                          .filter((option) => option.value !== allOption)
                          .map((option) => option.value);

                        let updatedSelectedMonetary: string[] = [];

                        if (
                          values.includes(allOption) &&
                          !monetaryFilter?.includes(allOption)
                        ) {
                          updatedSelectedMonetary = [
                            allOption,
                            ...listMonetaryFilter,
                          ];
                        } else if (
                          !values.includes(allOption) &&
                          monetaryFilter?.includes(allOption)
                        ) {
                          updatedSelectedMonetary = [];
                        } else {
                          const allSelected = listMonetaryFilter.every((s) =>
                            values.includes(s),
                          );

                          if (allSelected && !values.includes(allOption)) {
                            updatedSelectedMonetary = [
                              allOption,
                              ...listMonetaryFilter,
                            ];
                          } else {
                            updatedSelectedMonetary = values.filter(
                              (v) => v !== allOption,
                            );
                          }
                        }

                        setMonetaryFilter(updatedSelectedMonetary);
                      }}
                      maxTagPlaceholder={() => {
                        const allOption = monetaryOptions.find(
                          (option) => option.value === "all",
                        );
                        const allLabel = allOption
                          ? allOption.label
                          : "All Monetary Value";

                        if (!monetaryFilter || monetaryFilter.includes("all")) {
                          return allLabel;
                        }

                        if (monetaryFilter.length === 1) {
                          const selectedOption = monetaryOptions.find(
                            (option) => option.value === monetaryFilter[0],
                          );
                          return selectedOption?.label ?? monetaryFilter[0];
                        }

                        return `${monetaryFilter.length}/${
                          monetaryOptions.length - 1
                        } selected`;
                      }}
                      removeIcon={null}
                    />
                  </Form.Item>
                </Col>
              </>
            )}
            <Col span={24}>
              <Form.Item label="Goals Met Selector">
                <Select
                  style={{ width: "100%" }}
                  value={filterCampaign}
                  onChange={(val) => {
                    setFilterCampaign(val);
                  }}
                  placeholder={"Select Campaign"}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Row>
          <Button
            type="primary"
            style={{ width: "100%" }}
            onClick={applyAllFilter}>
            Apply Filter
          </Button>
        </Row>
      </Modal>
      <Modal
        title="Download Options"
        className="download-modal"
        open={isModalDownloadVisible}
        style={{ bottom: 0 }}
        footer={null}
        transitionName=""
        maskTransitionName=""
        maskClosable={false}
        onCancel={() => setIsModalDownloadVisible(false)}>
        {/* <Row style={{ marginBottom: 10 }}>
          <Checkbox
            checked={includePointBalance}
            onChange={(e) => setIncludePointBalance(e.target.checked)}
          >
            Include Point Balance
          </Checkbox>
        </Row>
        <Divider style={{ margin: "10px 0" }} />
        <Row style={{ marginBottom: 10 }}>
          <Checkbox
            checked={includeVoucherData}
            onChange={(e) => setIncludeVoucherData(e.target.checked)}
          >
            Include Voucher Data
          </Checkbox>
        </Row> */}
        <Space direction="vertical" style={{ width: "100%" }} size={8}>
          <Button
            size="large"
            block
            icon={<i className="icon-excel"></i>}
            onClick={() => handleDownloadNow()}
            loading={loading}>
            Download as Excel
          </Button>

          <Button
            size="large"
            block
            icon={<i className="icon-csv"></i>}
            onClick={() => handleDownloadNow()}
            loading={loading}>
            Download as CSV
          </Button>
        </Space>
        {/* <Row>
          <Button
            type="primary"
            style={{ width: "100%" }}
            onClick={handleDownloadNow}
            icon={<DownloadOutlined />}
          >
            Download Now
          </Button>
        </Row> */}
      </Modal>
      <Modal
        title="Columns"
        className="download-modal"
        open={isModalColumnVisible}
        style={{ bottom: 0 }}
        footer={null}
        transitionName=""
        maskTransitionName=""
        maskClosable={false}
        onCancel={cancelFilterColumn}>
        <div
          style={{
            maxHeight: 450,
            overflowY: "auto",
            paddingRight: 8,
            marginBottom: 5,
          }}>
          <Checkbox.Group
            value={selectedMobileKeys}
            onChange={(checkedValues) => setSelectedMobileKeys(checkedValues)}>
            <div style={{ maxHeight: 350, overflowY: "auto", width: "100%" }}>
              {options.map((option, index) => (
                <div
                  key={index}
                  style={{
                    padding: "8px 0",
                    borderBottom:
                      index !== options.length - 1
                        ? "1px solid #f0f0f0"
                        : "none",
                  }}>
                  <Checkbox value={option.value}>{option.label}</Checkbox>
                </div>
              ))}
            </div>
          </Checkbox.Group>
        </div>

        <Row>
          <Button
            type="primary"
            style={{ width: "100%" }}
            onClick={applyFilterColumn}>
            Apply Column
          </Button>
        </Row>
      </Modal>
      <RFMGeneratingModal visible={loading} />
    </>
  );
};

export default Home;
